export default {
    route: {
        dashboard: 'Quadre de comandament',
        article: 'Articles',
    },
    month: {
        jan: 'Gener',
        feb: 'Febrer',
        mar: 'Març',
        apr: 'Abril',
        may: 'Maig',
        jun: 'Juny',
        jul: 'Julio',
        aug: 'Agost',
        sep: 'Setembre',
        oct: 'Octubre',
        nov: 'Novembre',
        dec: 'Desembre',
    },
    week: {
        mon: 'dl',
        tue: 'dt',
        wed: 'dc',
        thu: 'dj',
        fri: 'dv',
        sat: 'ds',
        sun: 'dg',
    },
    navbar: {
        logOut: 'Tancar sessió',
        myProfile: 'El meu perfil',
        termsConditions: 'Condicions generals',
    },
    login: {
        title: 'Inici de sessió: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        logIn: 'Inici de sessió',
        username: "Nom d'usuari",
        password: 'Contrasenya',
        loginForm: {
            header: 'Benvingut a ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Introduïsca el codi del seu authenticator.',
            subheader: 'Introduïsca el codi de 6 dígits per a continuar',
            placeholderSecurityCode: 'Introduïsca ací el codi de seguretat',
        },
        forgotPassword: {
            header: 'Ha oblidat la seua contrasenya?',
            subheader:
                'Introduïsca la seua adreça de correu electrònic i li enviarem un missatge per a restablir la seua contrasenya',
            placeholderEmail: 'Introduïsca la seua adreça de correu electrònic',
        },
        resetPassord: {
            header: 'Restablisca la seua contrasenya.',
            subheader: 'Introduïsca el codi que li hem enviat per correu electrònic i restablix la seua contrasenya.',
            placeholder: {
                code: 'Introduïsca el seu codi',
                newPassWord: 'Introduïsca la seua nova contrasenya',
                confirmPassWord: 'Torne a confirmar la seua contrasenya',
            },
            success: "La seua contrasenya s'ha restablit correctament.",
        },
        button: {
            login: 'Inici de sessió',
            forgotPassword: 'Ha oblidat la seua contrasenya?',
            resetMyPassword: 'Restablir la meua contrasenya',
            submitMyPassword: 'Guardar nova contrasenya',
            back: 'Tornar',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Recordar',
            password: 'Contrasenya',
            userId: "ID d'usuari",
            copyright: 'Copyright ##COMPANY_BRAND_NAME##',
            showPassword: 'Mostrar contrasenya',
            hidePassword: 'Ocultar contrasenya',
        },
        errors: {
            email: {
                email: 'Introduïsca una adreça de correu electrònic vàlida.',
                required: 'Per favor, introduïsca la seua adreça de correu electrònic',
            },
            password: {
                required: 'Per favor, introduïsca la seua contrasenya',
                max: 'La contrasenya ha de tindre almenys 8 caràcters',
            },
            securityCode: {
                required: 'Per favor, introduïsca el seu codi de seguretat.',
                max: 'El codi de seguretat ha de tindre almenys 6 caràcters',
            },
            verificationCodeInvalid: 'Codi de verificació invàlid.',
            generalError: 'Error en processar la seua sol·licitud.',
            incorrectCredentials: "Nom d'usuari o contrasenya incorrectes.",
            defaultPasswordExpired: "La seua contrasenya ha caducat i l'ha de restablir un administrador.",
            inValidEmailAddress: "L'adreça de correu electrònic no és vàlida.",
            securityCodeInvalid: 'Codi de seguretat invàlid.',
            verificationCodeFormat: 'Per favor, introduïsca el codi de verificació de 6 dígits.',
            passwordFormat:
                'La contrasenya ha de tindre més de 15 caràcters, amb almenys una lletra majúscula, una lletra minúscula, un caràcter especial i un número.',
            confirmPasswordMatch: 'La contrasenya i la contrasenya de reconfirmació no coincidixen.',
            common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
        },
        toast: {
            error: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
        },
    },
    dashboard: {
        title: 'Inici: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Quadre de comandament',
        formtitle: 'Validació de formularis',
        label: {
            pending: 'Pendent',
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crèdit disponible',
            unbilledAmount: 'Import no facturat',
            filter: 'Filtre',
            reportTags: "Etiquetes de l'informe",
            driverGroup: 'Grups de conductors',
            selectDriverGroup: 'Seleccionar Grups de conductors',
            selectTags: 'Seleccionar Etiquetes',
            dateRange: 'Interval de dates',
            month: 'Mes',
            year: 'Any',
            day: 'Dia',
            week: 'Setmana',
            userSessionTitle: 'Sessions de conductors',
            userSessions: 'Sessions de conductors',
            expenseTitle: 'Suma de despeses',
            expense: 'Despeses',
            energyTitle: "Suma d'energia (kWh)",
            enrgy: 'Energia',
            averageTransationTitle: 'Transaccions mitjanes',
            transaction: 'Transaccions',
            creditLimit: 'Límit de crèdit',
            totalDriverAccounts: 'Total de comptes de conductors',
            enabled: 'Activat',
            disabled: 'Desactivat',
        },
        button: {
            apply: 'Sol·licitar',
            clear: 'Esborrar',
        },
        cpoType: {
            Both: 'Tots dos',
            Local: 'Local',
            International: 'Internacional',
        },
    },
    permission: {
        createArticle: 'Afegir articles',
        editArticle: 'Editar articles',
        save: 'Guardar',
        confirm: 'Està segur?',
        cancel: 'Cancel·lar',
        update: 'Actualització',
    },
    table: {
        pagination: {
            prev: 'Anterior',
            nrev: 'Següent',
            showing: 'Mostrar',
        },
        data: {
            noData: "No s'han trobat dades.",
        },
    },
    article: {
        title: "Gestionar l'article",
        id: "ID de l'article",
        date: 'Data',
        tabletitle: 'Títol',
        author: 'Autor',
        reviewer: 'Revisor',
        actions: 'Accions',
        saveMessage: 'Article guardat correctament',
        updateMessage: 'Article actualitzat correctament',
        deleteMessage: 'Article eliminat correctament',
    },
    user: {
        title: 'Usuaris: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        user: 'Usuaris',
        manageUser: "Gestionar l'usuari",
        placeholder: {
            name: 'Nom',
            email: 'Adreça de correu electrònic',
            phoneNo: 'Telèfon',
            firstName: 'Nom',
            lastName: 'Cognom(s)',
            userGroup: "Grups d'usuari",
            userRoles: "Funcions de l'usuari",
            Organisation: 'Organització',
            select: 'Seleccionar estat',
            selectOrganisation: 'Seleccionar Organització',
            selectUserGroup: "Seleccionar Grups d'usuari",
            languagePreference: 'Preferència lingüística',
        },
        label: {
            firstName: 'Nom',
            lastName: 'Cognom',
            email: 'Correu electrònic',
            phoneNo: 'Telèfon',
            optional: '(Opcional)',
            userGroups: "Grups d'usuari",
            userRoles: "Funcions de l'usuari",
            Organisation: 'Organització',
            createdDate: 'Data de creació',
            languagePreference: 'Preferència lingüística',
            id: 'Id',
            action: 'Acció',
            status: 'Estat',
            name: 'Nom',
            delete: 'Suprimir',
            enable: 'Activar',
            all: 'Tot',
            disable: 'Desactivar',
            enabled: 'Activat',
            disabled: 'Desactivat',
            pending: 'Pendent',
            reset2FA: 'Restablir 2FA',
            deleted: 'Suprimit',
            lastLoginDate: "Data de l'última connexió",
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            sendEmail: 'Enviar un correu electrònic',
            reset2FA: 'Restablir 2FA',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-ho?',
            enableConfirmMesage: 'Segur que vol activar-ho?',
            disableConfirmMesage: 'Segur que vol desactivar-ho?',
            sendMailConfirmMessage: 'Segur que vol enviar un correu electrònic?',
            mailSentSuccessMessage: 'Correu electrònic enviat correctament.',
            reset2FAConfirmMesage: 'Segur que vol activar 2FA per a este usuari?',
        },
        errors: {
            email: {
                required: "Per favor, introduïsca l'adreça de correu electrònic",
                email: 'Per favor, introduïsca una adreça de correu electrònic vàlida',
            },
            firstName: {
                required: 'Per favor, introduïsca el seu nom',
                valid: 'Per favor, introduïsca un nom vàlid',
            },
            lastName: {
                required: 'Per favor, introduïsca el(s) seu(s) cognom(s)',
                valid: 'Per favor, introduïsca un cognom vàlid',
            },
            phoneNo: {
                required: 'Per favor, introduïsca el(s) seu(s) cognom(s)',
                match: 'Introduïsca un número de telèfon',
            },
            userGroups: {
                required: "Seleccione almenys un grup d'usuaris",
            },
            organization: {
                required: 'Per favor, seleccione organització',
            },
        },
    },
    userGroup: {
        title: "Grup d'usuari: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
        manageUserGroup: "Gestionar Grup d'usuari",
        users: 'Usuaris',
        header: "Grups d'usuari",
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            edit: 'Editar',
            delete: 'Suprimir',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            add: 'Afegir',
            back: 'Tornar',
            enable: 'Activar',
            disable: 'Desactivar',
            permission: "Permís d'accés",
        },
        placeholder: {
            groupName: 'Nom del grup',
            users: 'Seleccionar Usuaris',
            select: 'Seleccionar Estat',
            organisation: 'Seleccionar Organització',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                "En eliminar este grup d'organització, eliminarem l'associació de grup per a una organització concreta, està segur que desitja continuar?",
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            enableConfirmMesage: 'Segur que vol activar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
        },
        label: {
            id: 'Id',
            name: 'Nom',
            description: 'Descripció',
            Organisation: 'Organització',
            createdBy: 'Creat per',
            status: 'Estat',
            modifiedBy: 'Modificat per',
            createdDate: 'Data de creació',
            modifiedDate: 'Data de modificació',
            action: 'Acció',
            groupName: 'Nom del grup',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            phoneNo: 'Número de telèfon',
            email: 'Adreça de correu electrònic',
            groupAccess: 'Accés de grup',
            selectUsers: 'Seleccionar Usuaris',
            enabled: 'Activat',
            disabled: 'Desactivat',
            yes: 'Sí',
            no: 'No',
        },
        form: {
            groupName: {
                label: 'Nom del grup',
                placeholder: 'Introduïsca el nom del grup',
            },
            description: {
                label: 'Descripció',
                placeholder: 'Introduir descripció',
            },
            Organisation: {
                label: 'Organització',
            },
        },
        errors: {
            groupName: {
                required: 'Per favor, introduïsca el nom del grup',
                valid: 'Per favor, introduïsca un nom del grup vàlid',
                max: 'Màxim 50 caràcters permesos',
            },
            description: {
                max: 'Màxim 255 caràcters permesos',
            },
            userList: {
                required: 'Seleccione almenys un usuari',
            },
        },
        permission: {
            header: 'Permís',
            label: {
                module: 'Mòdul',
                subModule: 'Submòdul',
                action: 'Acció',
            },
        },
    },
    transactions: {
        headerTitle:
            'Transaccions de Conductor - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Transaccions de Conductor',
        transaction: 'Transaccions',
        columns: {
            amount: 'Import',
            location: 'Ubicació',
            date: 'Data',
            milesAdded: 'Milles afegides',
            time: 'Temps',
            cost: 'Cost',
            energy: 'Energia',
            action: 'Acció',
            remark: 'Observacions',
            credit: 'Crèdit',
            debit: 'Dèbit',
            closing: 'Tancant',
            transaction: 'ID de Transaccions',
            name: 'Nom',
            type: 'Tipus',
            federatedAccount: 'Tipus de compte federat',
            reference_id: 'ID de referència',
        },
        form: {
            charge: 'Carregant',
            payment: 'Pagament',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exportar tot',
            driver: 'Conductor',
            vehicle: 'Vehicle',
            cardPayment: 'Pagament amb targeta',
            referralBonus: 'Bonificació per recomanació',
            rewards: 'Recompenses',
            transactionDetails: 'Detalls de la transacció',
            transaction_id: 'ID de transaccions',
            fullName: 'Nom complet',
            email: 'Correu electrònic',
            phone_number: 'Número de telèfon',
            viewFailedPayments: 'Veure pagaments fallits',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            back: 'Tornar',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data final',
            name: 'Nom',
            chargingStation: 'Estació de càrrega',
            selectType: 'Seleccionar tipus',
            transaction: 'ID de transaccions',
            reference_id: 'ID de referència',
        },
        message: {
            noDataToExport: 'No hi ha dades que exportar.',
            error: {
                common: 'Alguna cosa ha anat malament. Per favor intente-ho de nou',
            },
        },
    },
    driver: {
        title: 'Conductors: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Conductors',
        manageDriver: 'Gestionar el conductor',
        startCharge: 'Inici de càrrega remota',
        activities: 'Activitats',
        detail: 'Detalls del conductors',
        address_detail: 'Adreça',
        billing_address_detail: 'Adreça de facturació',
        chargeDetails: 'Detalls de càrrega',
        debtLetterHistory: 'Historial de cartes de deute',
        note: 'Inici de càrrega remota',
        charityAdded: 'Donació benèfica afegida',
        cd: 'cd',
        placeholder: {
            name: 'Nom',
            email: 'Adreça de correu electrònic',
            firstName: 'Nom',
            lastName: 'Cognom',
            payment_card: '4 últims dígits de la targeta de pagament',
            select: {
                status: 'Seleccionar estat',
                account_type: 'Seleccione el tipus de compte',
                payment_type: 'Seleccione tipus de pagament',
                driver_groups: 'Seleccione grups de conductors',
                driver_tags: 'Seleccione etiquetes',
                organization: 'Seleccione organització',
                promotion: 'Seleccione estat',
            },
            driverGroup: 'Grups de conductors',
            organization: 'Organització',
            account_type: 'Tipus de compte',
            payment_type: 'Tipus de pagament',
            referral_code: 'Codi de referència',
            driver_tags: 'Etiquetes',
            address: 'Adreça línia 1',
            address2: 'Adreça línia 2',
            city: 'Ciutat',
            county: 'Província',
            postal_code: 'Codi postal',
            billing_address: 'Adreça línia 1',
            billing_address2: 'Adreça línia 2',
            billing_city: 'Ciutat',
            billing_county: 'Província',
            billing_postal_code: 'Codi postal',
            promotion: 'Promocions',
            currentDriverPromotion: 'Promoció actual',
            driverPromotionJoinDate: "Data d'incorporació",
            chargeLocation: 'Ubicació',
            chargeStation: 'Estació',
            connector: 'Connector',
            limitedKWH: 'KWh limitats:',
            confirmationNote:
                "Per seguretat del compte, confirme el nom, els cognoms, l'adreça de la línia 1 i el codi postal del conductor individual abans d'iniciar la càrrega remota. Per favor, marque la casella després de la confirmació del client",
            rfidCard: 'Targeta RFID',
            confirmationNoteFleet: 'Per favor, confirme esta contrasenya amb el conductor:',
            vehicle_number: 'Número de vehicle',
            api_url: 'URL API',
            startDate: "Data d'inici",
            endDate: 'Data final',
            publicRFID: 'Identificació pública amb targeta RFID',
            languagePreference: 'Preferència lingüística',
            searchAddress: 'Adreça',
        },
        label: {
            firstName: 'Nom',
            lastName: 'Cognom(s)',
            email: 'Correu electrònic',
            group: 'Grup',
            driverGroups: 'Grups de conductors',
            driver_tags: 'Etiquetes',
            organization: 'Organització',
            payment_type: 'Tipus de pagament',
            referral_code: 'Codi de referència',
            createdDate: 'Data de creació',
            id: 'Id',
            action: 'Acció',
            status: 'Estat',
            account_type: 'Tipus de compte',
            type: 'Tipus',
            name: 'Nom',
            delete: 'Suprimir',
            enable: 'Activar',
            all: 'Tot',
            disable: 'Desactivar',
            enabled: 'Activat',
            disabled: 'Desactivat',
            cancelled: 'Cancel·lat',
            deleted: 'Suprimit',
            address: 'Adreça',
            address2: 'Adreça línia 2',
            city: 'Ciutat',
            county: 'Província',
            postal_code: 'Codi postal',
            billing_address: 'Adreça línia 1',
            billing_address2: 'Adreça línia 2',
            billing_city: 'Ciutat',
            billing_county: 'Província',
            billing_postal_code: 'Codi postal',
            promotion: 'Promocions',
            expired: ' - Caducat',
            currentDriverPromotion: 'Promoció actual',
            driverPromotionJoinDate: "Data d'incorporació",
            vehicleNumber: 'Número de vehicle',
            paymentCard: 'Targeta de Pagament',
            cardType: 'Tipus de targeta',
            cardNumber: 'Núm. de targeta (4 últims dígits)',
            cardTitle: 'Títol de la targeta',
            cardExpiry: 'Data de caducitat de la targeta',
            paymentServiceProvider: 'Proveïdor de servicis de pagament',
            viewReferral: 'Veure remissió',
            referralDetails: 'Detalls de la remissió',
            referrer_name: 'Nom del remitent',
            referral_name: 'Nom del remitent',
            referral_bonus: 'Bonificació per recomanació',
            referralBonusStatus: 'Estat de la bonificació per recomanació',
            referee_Name: 'Nom del mediador',
            noRecords: 'No hi ha registres per a mostrar',
            noReferralsMessage: 'Sense remission(s)',
            referrerName: 'Nom de referència del referenciat: ',
            referralCode: 'Codi de referència del referenciat:',
            noReferrerMessage: 'Sense referenciat',
            current_balance: 'Saldo actual',
            referral_balance: 'Saldo de referència',
            account_balance: 'Saldo del compte',
            rewards_balance: 'Saldo de recompenses',
            balanceDetails: 'Details del saldo',
            federated_account_type: 'Tipus de compte federat',
            pending: 'Pendent',
            rfidCard: 'Targeta RFID',
            startCharge: 'Iniciar càrrega remota',
            chargeLocation: 'Ubicació',
            chargeStation: 'Estació',
            connector: 'Connector',
            limitedKWH: 'KWh limitats:',
            confirmationNote:
                "Per seguretat del compte, confirme el nom, els cognoms, l'adreça de la línia 1 i el codi postal del conductor individual abans d'iniciar la càrrega remota. Per favor, marque la casella després de la confirmació del client",
            fullName: 'Nom complet',
            phoneNo: 'Número de telèfon',
            confirmationNoteFleet: 'Per favor, confirme esta contrasenya amb el conductor:',
            chargingStartedMessage: "Sol·licitud de càrrega remota d'inici realitzada amb èxit",
            resetPassword: 'Restablir contrasenya',
            password: 'Contrasenya',
            disablePaymentCard: 'Desactivar Targeta de Pagament',
            requestedData: 'Dades sol·licitades',
            apiURL: 'API',
            viewData: 'Veure dades',
            deletionEmailSent: "Correu electrònic d'eliminació de compte enviat",
            yes: 'Sí',
            onstop: 'En parada',
            badDebtor: 'Deutor morós',
            available: 'Disponible',
            languagePreference: 'Preferència lingüística',
            fakeAccount: 'Compte fals',
            addNotes: 'Afegir notes',
            newNote: 'Nova Nota',
            addNote: 'Afegir nota',
            existingNotes: 'Notes existents',
            viewNotes: 'Veure notes',
            notes: 'Notes:',
            financialDetails: 'Dades financeres',
            uniqueID: 'Identificació única',
            dateGenerated: 'Data de creació',
            debtValue: 'Valor del deute',
            letterTemplate: 'Model de carta utilitzat',
            lastCardValidationDate: 'Última data de validació de la targeta',
        },
        account_type: {
            driver: 'Conductor',
            vehicle: 'Vehicle',
        },
        payment_type: {
            credit_account: 'Compte de crèdit',
            prepayment_account: 'Compte de pagament anticipat',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            sendEmail: 'Enviar un correu electrònic',
            viewTransactions: 'Veure Transaccions',
            close: 'Tancar',
            startCharge: 'Iniciar càrrega remota',
            startChargeBtn: 'Iniciar càrrega',
            resetPassword: 'Restablir Contrasenya',
            submit: 'Enviar',
            amendBalance: 'Modificar saldo',
            viewActivities: 'Veure Activitats',
            premiumSubscriptions: 'Subscripcions Premium',
            markAsFake: 'Marcar com a compte fals',
            addNotes: 'Afegir notes',
            debtLetterHistory: 'Historial de cartes de deute',
            enableReferralCode: 'Activar codi de referència',
            disableReferralCode: 'Desactivar codi de referència',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            enableConfirmMesage: 'Segur que vol activar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
            sendMailConfirmMessage: 'Segur que vol enviar un correu electrònic?',
            mailSentSuccessMessage: 'Correu electrònic enviat correctament.',
            resetPasswordConfirmMesage: 'Està segur que vol restablir la contrasenya per a este usuari?',
            deleteDriverConfirmMesage: "Està segur que desitja eliminar el compte d'este conductor?",
            markAsFakeConfirmMessage:
                "Desitja marcar este compte de conductor com a fals, es tracta d'un procés unidireccional en el qual s'esborra la informació.",
            enableReferralCodeConfirmMesage:
                'Està segur que desitja activar el codi de referència per a este controlador?',
            disableReferralCodeConfirmMesage:
                'Està segur que desitja desactivar el codi de referència per a este controlador?',
        },
        errors: {
            driverGroups: {
                required: 'Seleccione almenys un grup de conductor',
            },
            organization: {
                required: "Per favor, seleccione l'organització",
            },
            tag: {
                invalid_fromat: "Caràcters no vàlids en l'etiqueta",
            },
            fullName: {
                valid: 'Per favor, introduïsca un nom vàlid',
            },
            phoneNo: {
                match: 'Introduïsca un número de telèfon',
            },
            email: {
                required: "Per favor, introduïsca l'adreça de correu electrònic",
                email: 'Per favor, introduïsca una adreça de correu electrònic vàlida',
            },
            password: {
                passwordFormat:
                    'La contrasenya ha de tindre més de 10 caràcters, amb almenys una lletra majúscula, una lletra minúscula, un caràcter especial i un número.',
            },
        },
    },
    driverGroup: {
        title: 'Grup de conductors: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        titleFleet: 'Grup: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        manageDriverGroup: 'Gestionar el grup del conductor',
        manageDriverGroupFleet: 'Gestionar Grup',
        driversList: 'Conductors',
        driversListFleet: 'Conductors/vehicles',
        header: 'Grups de conductors',
        headerFleet: 'Grups',
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            edit: 'Editar',
            delete: 'Suprimir',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            add: 'Afegir',
            back: 'Tornar',
            enable: 'Activar',
            disable: 'Desactivar',
        },
        placeholder: {
            groupName: 'Nom del grup',
            drivers: 'Seleccionar conductors',
            driversFleet: 'Seleccionar conductors/vehicles',
            select: 'Seleccionar estat',
            selectType: 'Seleccionar tipus',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo(s)?',
            enableConfirmMesage: 'Segur que vol activar-lo(s)?',
            disableConfirmMesage: 'Segur que vol desactivar-lo(s)?',
        },
        label: {
            id: 'Id',
            name: 'Nom',
            description: 'Descripció',
            organization: 'Organització',
            createdBy: 'Creat per',
            status: 'Estat',
            modifiedBy: 'Modificat per',
            createdDate: 'Data de creació',
            modifiedDate: 'Data de modificació',
            action: 'Acció',
            groupName: 'Nom del grup',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            phoneNo: 'Número de telèfon',
            email: 'Adreça de correu electrònic',
            groupAccess: 'Accés de grup',
            selectDrivers: 'Seleccionar conductors',
            selectDriversFleet: 'Seleccionar conductors/vehicles',
            enabled: 'Activat',
            disabled: 'Desactivat',
            yes: 'Sí',
            no: 'No',
            vehicle_number: 'Núm. vehicle',
            type: 'Tipus',
            updateDriverAssociation: "Actualitzar l'associació de conductors",
            addToThisGroup: 'Afegir a este grup',
            cancel: 'Cancel·lar',
        },
        form: {
            groupName: {
                label: 'Nom del grup',
                placeholder: 'Introduïsca el nom del grup',
            },
            description: {
                label: 'Descripció',
                placeholder: 'Introduir descripció',
            },
        },
        errors: {
            groupName: {
                required: 'Per favor, introduïsca el nom del grup',
                valid: 'Per favor, introduïsca un nom del grup vàlid',
                max: 'Màxim 50 caràcters permesos',
            },
            description: {
                max: 'Màxim 255 caràcters permesos',
            },
            driverList: {
                required: "Seleccione almenys un grup d'usuaris",
                requiredfleet: 'Seleccione almenys un conductor/vehicule',
            },
            spendLimit: {
                valid: 'Per favor, introduïsca almenys un valor límit de despesa',
            },
        },
    },
    vat: {
        title: 'IVA: ##COMPANY_BRAND_NAME##',
        vat: 'IVA',
        manageVat: "Gestionar l'IVA",
        label: {
            name: 'Nom',
            description: 'Descripció',
            rate: 'Tarifa',
            createdDate: 'Data de creació',
            action: 'Acció',
            status: 'Estat',
            disabled: 'Desactivat',
            enabled: 'Activat',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            defaultVAT: 'IVA per defecte',
            yes: 'Sí',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            enableConfirmMesage: 'Segur que vol activar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
            setDefaultConfirmMesage: 'Està segur que desitja establir este IVA per defecte?',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            setDefaultVAT: 'establir per defecte',
        },
        placeholder: {
            select: 'Seleccionar estat',
            name: 'Nom',
            description: 'Descripció',
            rate: 'Tarifa',
        },
        errors: {
            name: {
                valid: 'Introduïsca un nom vàlid',
            },
            rate: {
                max: 'La taxa no pot ser superior a 100',
                min: 'La taxa no pot ser menys que 0',
                number: 'La taxa ha de ser un número',
            },
            description: {
                valid: 'Introduir una descripció vàlida',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Sí',
            no: 'No',
            proceed: 'Procedisca',
            cancel: 'Cancel·lar',
        },
    },
    tag: {
        title: 'Etiquetes: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        tag: 'Etiquetes',
        manageUser: 'Gestionar usuaris',
        placeholder: {
            name: "Nom de l'etiqueta",
            select: 'Seleccionar',
        },
        label: {
            name: "Nom de l'etiqueta",
            driver_count: 'Recompte de conductors',
            charge_location_count: 'Recompte de la ubicació de la càrrega',
            action: 'Acció',
            delete: 'Suprimir',
            editHeader: 'Editar etiqueta',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
        },
        message: {
            deleteConfirmMesage:
                "L'etiqueta s'eliminarà de tots els controladors associats i de la ubicació de càrrega. Segur que vol eliminar-la?",
        },
        errors: {
            name: "Caràcters no vàlids en l'etiqueta",
        },
    },
    chargeStation: {
        title: 'Estacions de recàrrega: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        chargeStations: 'Estacions de recàrrega',
        manageVat: "Gestionar l'estació de recàrrega",
        label: {
            modifiedDate: 'Data de modificació',
            importChargeStationHeader: 'Importar Estació de recàrrega',
            csvFile: 'Arxiu CSV',
            manageAmenities: 'Gestionar servicis',
            chargePoint: 'Punt de recàrrega',
            allLocations: 'Totes Ubicacions',
            assignedLocation: 'Ubicació assignada',
            unassignedLocation: 'Ubicació sense assignar',
            chargeLocation: {
                cp_id: 'CP-Id',
                type: 'Tipus',
                name: 'Nom',
                locationName: 'Nom de la ubicació',
                address: 'Adreça',
                city: 'Ciutat',
                postal_code: 'Codi postal',
                chargePoint: 'Punt de recàrrega',
                appliesToOrg: "S'aplica a l'organització",
                associatedTariff: 'Tarifa associada',
                associatedPromotion: 'Promoció associada',
                gmbLocationId: "Identificació d'ubicació de GMB",
            },
            chargeStation: {
                uid: 'UId',
                evse_id: 'ID EVSE',
                status: 'Estat',
                physicalReference: 'Referència física',
                city: 'Ciutat',
                postal_code: 'Codi postal',
            },
            stationConnector: {
                connector_id: 'Identificació del Connector',
                standard: 'Estàndard',
                format: 'Format com a tipus',
                power_type: 'Tipus de potència',
                voltage: 'Tensió',
                amperage: 'Amperatge',
                power_rating: 'Potència nominal',
            },
            selectTag: 'Seleccionar Etiquetes',
            addTagHeader: 'Etiquetes associades',
            tags: 'Etiquetes',
            yes: 'Sí',
            assignedTariff: 'Assignar tarifa',
            assignTariff: 'Assignar tarifa a ubicacions',
            delete: 'Suprimir',
            action: 'Acció',
            addPromotion: 'Afegir promoció',
            selectPromotion: 'Seleccione promoció',
            exportChargeStations: {
                connector_id: 'connector_id',
                max_power: 'max_power',
                cp_id: 'cp_id',
                type: 'tipus',
                location: 'ubicació',
                station_name: 'station_name',
                address: 'adreça',
                city: 'ciutat',
                postal_code: 'postal_code',
                country: 'país',
                latitude: 'latitud',
                longitude: 'longitud',
                evse_id: 'evse_id',
                standard: 'estàndard',
                format: 'format',
                powertype: "tipus d'energia",
                voltage: 'tensió',
                amperage: 'amperatge',
            },
            gmbLocationID: "Identificació d'ubicació de GMB",
            clickHere: 'Polse ací',
            downloadTemplate: 'per a descarregar plantilla',
            importStationsModel: 'Model per a importar estació de recàrrega',
            noDataToExport: 'No hi ha dades que exportar.',
            note: 'Nota: ',
            autoCalculateMaxPowerNote:
                'Alguns CPOs han sigut configurats per a calcular automàticament la potència màxima, amb esta importació es podrien sobreescriure els valors calculats.',
            applyToOrg: "Aplicable a tota l'Organització",
        },
        errors: {
            tag: {
                invalid_fromat: "Caràcters no vàlids en l'etiqueta",
            },
            file: {
                fileType: "Es poden penjar arxius amb extensió'.csv'.",
            },
            gmbLocationId: {
                valid: "Introduïsca una identificació d'ubicació GMB vàlida",
            },
            common: 'Alguna cosa ha anat malament. Per favor intente-ho de nou',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            edit: 'Editar',
            expand: 'Ampliar',
            collapse: 'Col·lapse',
            import: 'Importar',
            synchronize: 'Sincronitze',
            syncStation: 'Sincronitze estació',
            assignTariff: 'Assignar tarifa',
            delete: 'Suprimir',
            add: 'Afegir',
            addSelected: 'Afegir el seleccionat',
            addAll: 'Afegir-ho tot',
            yes: 'Sí',
            no: 'No',
            back: 'Tornar',
            apply: 'Sol·licitar',
            editGMBLocationID: "Editar identificació d'ubicació de GMB",
            downloadLocationsData: 'Extraure les dades dels punts de recàrrega',
            exportAll: 'Exportar tot',
            importStationsModel: 'Model per a importar estació de recàrrega',
            deleteSelected: 'Esborrar seleccionats',
            export: 'Exportar',
        },
        placeholder: {
            selectStationStatus: 'Seleccionar estat',
            name: 'Nom',
            cp_id: 'CP-Id',
            tags: 'Etiquetes',
            address: 'Adreça',
            selectTag: 'Seleccionar Etiquetes',
            evse_id: 'ID EVSE',
            selectChargePoint: 'Seleccionar CPO',
            selectRegion: 'Seleccionar regió',
            selectPromotion: 'Seleccione promoció',
            gmbLocationID: "Identificació d'ubicació de GMB",
            selectPowerType: "Seleccione el tipus d'alimentació",
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-la?',
            addPromotion: 'Detalls de la promoció actualitzats correctament',
            updateAmenitiesSuccess: "Els servicis d'ubicació de recàrregues s'han actualitzat correctament",
            chargePointRequire: 'Es requerix almenys un punt de recàrrega',
            deleteBulkConfirmMessage: 'Està segur que desitja eliminar els registres seleccionats?',
            applyToAllOrgConfirmMessage:
                'Desitja aplicar esta tarifa també a les organitzacions de totes les ubicacions? ',
        },
        manageAmenities: 'Gestionar servicis',
    },
    chargeStationMap: {
        title: "Vista del mapa d'estacions de recàrrega: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
        header: 'Estacions de recàrrega',
        label: {
            address: 'Adreça',
            backOfficeUrl: 'URL del back office',
            amenities: 'Servicis:',
            satellite: 'Satèl·lit',
            map: 'Mapa',
            search: 'Buscar',
            refresh: 'Actualitzar',
            apply: 'Sol·licitar',
            clear: 'Esborrar',
            loading: 'Carregant...',
        },
        placeholder: {
            locationSearch: 'Buscar estació',
            mapSearch: 'Buscar per nom de carrer, ciutat o codi postal',
        },
    },
    promotionsRequest: {
        headerTitle: 'Sol·licitud de promoció de conductors: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        title: ' Sol·licitud de promoció de conductors',
        promotionsRequest: 'Promocions sol·licitades',
        columns: {
            driverName: 'Nom del conductor',
            promotionsName: 'Nom de les promocions',
            promotionsCode: 'Codí',
            approved: 'Estat',
            approvedBy: 'Modificat per',
            approvedDate: 'Data de modificació',
            action: 'Acció',
            email: 'Correu electrònic',
        },
        form: {
            charge: 'Carregant',
            payment: 'Pagament',
            month: 'Mes',
        },
        label: {
            approved: 'Aprovat',
            pending: 'Pendent',
            rejected: 'Rebutjat',
            modelHeader: 'Promocions sol·licitades - ',
            enterComment: 'Introduïsca els seus comentaris',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            back: 'Tornar',
            approved: 'Aprovar',
            pending: 'Pendent',
            rejected: 'Rebutjar',
            action: 'Acció',
            edit: 'Editar',
        },
        placeholder: {
            driverName: 'Nom del conductor',
            promotionsName: 'Nom de les promocions',
            promotionsCode: 'Codí',
            select: 'Seleccionar estat',
        },
        message: {
            ManagestatusMesage:
                "Faça clic en Aprovat o Rebutjat per a aplicar l'estat de la sol·licitud. Una vegada s'actualitze esta sol·licitud, ja no podrà editar-se.",
        },
    },
    driverAccountBalance: {
        title: 'Saldo del compte del conductor: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        driverAccountBalance: 'Saldo del compte del conductor',
        manageUser: 'Gestionar saldo del compte del conductor',
        placeholder: {
            name: 'Nom/Correu electrònic',
            select: 'Seleccionar estat',
            payment_type: 'Seleccione tipus de pagament',
            description: 'Comentari',
            amount: "Introduïsca l'import a abonar o deure",
        },
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            payment_type: 'Tipus de Pagament',
            driver_status: 'Estat del compte',
            current_balance: 'Saldo',
            currency: 'Divisa',
            driver_id: 'Identificació del conductor',
            action: 'Acció',
            delete: 'Suprimir',
            refundHeader: 'Retirada',
            creditPayment: 'Compte de crèdit',
            prePayment: 'Compte de pagament anticipat',
            enabled: 'Activat',
            disabled: 'Desactivat',
            refund: 'Modificar el saldo del compte',
            description: 'Comentari',
            amount: "Introduïsca l'import a abonar o deure",
            additional_payment: 'Pagament addicional',
            payment_refunds: 'Retirada de pagaments',
            payment_settlement: 'Modificació del saldo - Sol·licitud',
            balance: 'Tipus de Saldo',
            accountBalance: 'Fons del compte',
            referralBonus: 'Bonificació per recomanació',
            rewardBalance: 'Saldo de recompenses',
            total_balance: 'Saldo total',
            rewards: 'Recompenses',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            send_for_approval: 'Enviar per a aprovació',
        },
        message: {
            deleteConfirmMesage:
                "L'etiqueta s'eliminarà de tots els controladors associats i de la ubicació de càrrega. Segur que vol eliminar-la?",
        },
        errors: {
            name: "Caràcters no vàlids en l'etiqueta",
            amount: {
                moreThan: "L'import ha de ser major/menor que 0",
                maxcredit: "Límit màxim aconseguit per a l'abonament en compte",
                maxdebit: 'Límit màxim de deute en compte aconseguit',
            },
        },
    },
    driverPromotions: {
        title: 'Gestionar promoció: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        manageDriverPromotion: 'Gestionar promoció',
        driverPromotions: 'Promocions',
        label: {
            name: 'Nom',
            code: 'Codí',
            errorMessage: "Missatge d'error",
            used: 'Utilitzat',
            unUsed: 'No utilitzat',
            uploadFileErrorMessage: 'Errors en penjar codis promocionals.',
            updatePromotionCode: 'Actualitzar codi promocional',
            unique_code: 'Codi únic',
            uniquePromotionCode: 'Codis de Promocions',
            importDriverPromotionCodeHeader: 'Importar codi promocional del conductor',
            csvFile: 'Codis de Promocions',
            promotionCode: 'Codi de Promocions',
            usedBy: 'Utilitzat per',
            description: 'Descripció',
            tarrif: 'Tarifa',
            accountCredit: 'Crèdit en compte',
            discountRatePeriod: 'Període de la taxa de descompte',
            indays: '(Dies)',
            intilakWhRate: 'Taxa kWh inicial',
            ivRewardsPromotion: 'IV Promoció de recompensa',
            referralPromotion: 'Promoció per recomanació',
            expiryDate: 'Data de caducitat',
            needApprovalToJoinPromotion: 'Necessita aprovació per a unir-se a la promoció',
            newDriversOnly: 'Només nous conductors',
            forOrganisation: "Per a l'Organització",
            createdDate: 'Data de creació',
            action: 'Acció',
            status: 'Estat',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            enabled: 'Activat',
            disabled: 'Desactivat',
            deleted: '(Suprimit)',
            csvFileSupported: "Només s'admeten arxius CSV",
            clickHere: 'Polse ací',
            downloadTemplate: 'per a descarregar la plantilla',
            exportColumnHeder: 'promotion_codes',
            min_kwh_package_promotion: 'Mínim kWh',
            package_promotion_period: 'Període de promoció del paquet (dies)',
            package_promotion_volt_bonus: 'Nombre de volts designats',
            rfidCardUnitPrice: 'Preu unitari de la targeta RFID',
            subscription: 'Subscripció Premium',
            tariffUpdate: 'Actualització de tarifa',
            currentTariff: 'Tarifa actual',
            next: 'Següent',
            newTariff: 'Nova tarifa',
            save: 'Guardar',
        },
        placeholder: {
            name: 'Nom',
            promotionCode: 'Codi de Promocions',
            selectTariff: 'Seleccionar tarifa',
            selectStatus: 'Seleccionar estat',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            forOrganisation: "Per a l'Organització",
            min_kwh_package_promotion: 'Mínim kWh',
            package_promotion_period: 'Període de promoció del paquet',
            package_promotion_volt_bonus: 'Nombre de volts designats',
            rfidCardUnitPrice: 'Preu unitari de la targeta RFID',
            premium_subscription: 'Subscripció Premium',
            selectCurrentTariff: 'Seleccionar tarifa actual',
            selectNewTariff: 'Seleccionar nova tarifa',
        },
        button: {
            update: 'Actualització',
            import: 'Importar',
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
        },
        message: {
            deleteConfirmMesage: 'Segur que vols eliminar-la?',
            enableConfirmMesage: 'Segur que vols activar-la?',
            disableConfirmMesage: 'Segur que vols desactivar-la?',
            subscriptionChangeWarningMessage:
                'Avís: en canviar el tipus de subscripció, es cancel·laran totes les renovacions automàtiques del compte de conductor associat.',
            tariffUpdateNote: "La nova tarifa s'assignarà a les següents promocions:",
            updateTariffConfirmMessage: 'Està segur que desitja actualitzar la tarifa de les promocions seleccionades?',
            selectOneRecord: 'Seleccione almenys una promoció per a actualitzar les tarifes',
        },
        errors: {
            promotionName: {
                valid: 'Introduïsca un nom vàlid de promoció',
            },
            promotionCode: {
                valid: 'Introduïsca un codi vàlid de promoció',
            },
            accountCredit: {
                moreThan: 'El crèdit del compte ha de ser superior a 0',
                max: "Límit màxim aconseguit per a l'abonament en compte",
                typeError: 'Introduïsca un import de crèdit acumulat vàlid',
            },
            discountRatePeriod: {
                moreThan: 'El període de la taxa de descompte ha de ser superior a 0',
            },
            intialRate: {
                max: 'La taxa no pot ser superior a 100',
                min: 'La taxa no pot ser menys que 0',
                typeError: 'Introduïsca una taxa vàlida',
            },
            common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
            file: {
                fileType: "Es poden penjar arxius amb extensió'.csv'.",
            },
            maxValue: 'El valor màxim no ha de superar 2147483647',
            rfidCardUnitPrice: {
                max: 'El preu unitari de la targeta RFID no pot ser superior a 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle:
            'Aprovació de saldos - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Aprovació de saldos',
        transaction: 'Transaccions',
        columns: {
            email: 'Correu electrònic',
            amount: 'Import',
            status: 'Estat',
            request_by: 'Sol·licitat per',
            request_date: "Sol·licitat el/l'",
            request_by_comment: 'Sol·licitat per Comentaris',
            review_by: 'Revisat per',
            review_date: "Revisat el/l'",
            review_comment: 'Revisar Comentaris',
            credit: 'Crèdit',
            debit: 'Dèbit',
            closing: 'Tancant',
            transaction: 'ID de Transaccions',
            name: 'Nom',
            action: 'Acció',
            request_type: 'Tipus de sol·licitud',
            invoice: 'Factura',
        },
        form: {
            driver: 'Conductor',
            organisation: 'Organització',
            month: 'Mes',
        },
        label: {
            request_type: 'Tipus de sol·licitud',
            refundHeader: 'Modificació del saldo',
            pending: 'Pendent',
            approved: 'Aprovar',
            declined: 'Rebutjar',
            approve: 'Aprovar',
            decline: 'Rebutjar',
            comment: 'Introduïsca els seus comentaris',
            status: 'Estat',
            refund: 'Aprovar crèdit/dèbit',
            refundAmount: 'Import de la retirada ',
            commentsFrom: 'Comentaris de',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
        },
        placeholder: {
            comment: 'Introduïsca els seus comentaris',
            status: 'Seleccionar estat',
            name: 'Nom/Correu electrònic',
            refundAmount: 'Import de la retirada ',
        },
        message: {
            noDataToExport: 'No hi ha dades que exportar.',
            selectApprovalOrReject: 'Per favor, aprove o rebutge esta sol·licitud.',
        },
    },
    paymentScheduleSetting: {
        title: 'Ajust del calendari de pagaments: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Calendari de Pagament',
        note: 'Programe un treball en segon pla per a liquidar les factures pendents per la recàrrega del VE realitzada pels conductors.',
        placeholder: {
            day_of_week: 'Dia de la setmana',
        },
        label: {
            daily: 'Diàriament',
            weekly: 'Setmanal',
            day_of_week: 'Dia de la setmana',
            selectDay: 'Seleccionar Dia',
        },
        day_of_week: {
            monday: 'DILLUNS',
            tuesday: 'DIMARTS',
            wednesday: 'DIMERCRES',
            thursday: 'DIJOUS',
            friday: 'DIVENDRES',
            saturday: 'DISSABTE',
            sunday: 'DIUMENGE',
        },
        button: {
            save: 'Guardar',
        },
    },
    paymentFailures: {
        title: 'Fallades en els pagaments: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        managePaymentFailures: 'Fallades en els pagaments',
        placeholder: {
            name: 'Nom/Correu electrònic',
            note: 'Observació',
            startDate: "Data d'inici",
            endDate: 'Data final',
            select: 'Seleccionar estat',
            status: 'Seleccionar estat',
            failureReason: 'Motiu de la fallada',
        },
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            transaction_id: 'ID de Transaccions',
            total_amount: 'Import total',
            currency_name: 'Divisa',
            created_date: 'Data de creació',
            status: 'Estat',
            note: 'Observació',
            action: 'Acció',
            editHeader: "Actualitzar l'estat del pagament",
            pending: 'Pendent',
            acknowledged: 'Reconegut',
            closed: 'Tancat',
            transactionDetails: 'Detalls de la transacció',
            transaction_request: 'Sol·licitud de transacció',
            transaction_response: 'Resposta a la transacció',
            error_message: "Missatge d'error",
            error_code: "Codi d'error",
            request_type: 'Tipus de sol·licitud',
            response_code: 'Codi de resposta',
            response_code_description: 'Descripció del codi de resposta',
            null_data: "No s'han trobat dades.",
            transaction_date: 'Dates de les transaccions',
            failureReason: 'Motiu de la fallada',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar estat',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            back: 'Tornar',
        },
    },
    chargeTariff: {
        title: 'Tarifes: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Tarifes',
        tariff: 'Tarifa',
        label: {
            name: 'Nom',
            vat_name: 'Nom IVA',
            vat_rate: 'Taxa (%)',
            vat_description: 'Descripció',
            cpo_id: 'cpo Id',
            action: 'Acció',
            url: 'URL',
            currency: 'Divisa',
            createdDate: 'Data de creació',
            status: 'Estat',
            enabled: 'Activat',
            deleted: 'Suprimit',
            detail: 'Detall',
            promotions: 'Promocions',
            lastUpdated: 'Última actualització el',
            promotionCode: 'Codi de Promocions',
            description: 'Descripció',
            expiryDate: 'Data de caducitat',
            priceComponents: 'Components del preu',
            priceComponent: 'Component del preu',
            type: 'TIPUS',
            price: 'PREU',
            pricePerHour: 'Preu (per hora)',
            restriction: 'Restricció',
            startDate: "Data d'inici",
            startTime: "Data d'inici",
            endDate: 'Data final',
            endTime: 'Temps final',
            minkWh: 'Mínim kWh',
            maxkWh: 'Màx. kWh',
            minPower: 'Potència Mínima',
            maxPower: 'Potència Màxima',
            minDuration: 'Duració Mín',
            maxDuration: 'Duració Màx',
            weekDays: 'Dies de la setmana',
            selectVat: 'Seleccionar IVA',
            attachVat: "Adjuntar l'IVA",
            vatdetail: "Detall de l'IVA",
            editVAT: "Editar tipus d'IVA",
            vatType: "Tipus d'IVA",
            tariffID: 'ID de la tarifa',
            element: 'ELEMENT',
            prices: 'Preus',
            restrictions: 'Restriccions',
            stepSize: 'GRANULARITAT',
            vat: 'IVA',
            date: 'DATA',
            time: 'HORA',
            kwh: 'KWH',
            power: 'POTÈNCIA (KW)',
            duration: 'DURADA (SEC)',
            current: 'CORRENT (AMP)',
            maxCurrent: 'Corrent Màxim',
            minCurrent: 'Corrent Mínim',
            restrictionTitle: 'RESTRICCIÓ',
            details: 'Detalls',
            weekDaysTitle: 'DIES DE LA SETMANA',
            maxKwhTitle: 'KWH Màxim',
            minKwhTitle: 'KWH Mínim',
        },
        placeholder: {
            name: 'Nom',
            selectStatus: 'Seleccionar estat',
            selectVat: 'Seleccionar IVA',
            selectType: 'Seleccionar Tipus IVA',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            detail: 'Detall',
            add: 'Afegir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            editvat: "Adjuntar l'IVA",
            editVAT: 'Editar tipus IVA',
            groupRestrictions: 'Restriccions de Tarifa de Grup',
            ungroupRestrictions: 'Restriccions de Tarifa No Agrupada',
        },
        noRestrictionAvailable: 'Cap Restricció Disponible',
    },
    partnerPromotion: {
        title: 'Promocions per a socis: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Promocions per a socis',
        placeholder: {
            nameorcompany: 'Nom o empresa',
            status: 'Seleccionar estat',
            date_from: "Data d'inici",
            date_to: 'Data de finalització',
        },
        label: {
            name: 'Nom',
            company: 'Empresa',
            description: 'Descripció',
            date_from: "Data d'inici",
            date_to: 'Data de finalització',
            expiry_date: 'Data de caducitat',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activat',
            disabled: 'Desactivat',
            delete: 'Suprimir',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            enable: 'Activar',
            disable: 'Desactivar',
            chargeStation: 'Estacions de recàrrega',
            preview: 'Vista prèvia',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-la?',
            enableConfirmMesage: 'Segur que vol activar-la?',
            disableConfirmMesage: 'Segur que vol desactivar-la?',
        },
        insert: {
            header: 'Gestionar promocions de socis',
            placeholder: {
                name: 'Nom',
                company: "Informació sobre l'empresa",
                description: 'Descripció',
                start_date: "Data d'inici",
                expiry_date: 'Data de caducitat',
                offer_duration: '60 minuts',
                stored_for_future_use_days: '2 dias',
                qr_code_details: 'Informació sobre el codi QR',
                certificate: 'Certificat',
                image: 'Oferir imatge',
                image1: 'Imatge addicional 1',
                image2: 'Imatge addicional 2',
                image3: 'Imatge addicional 3',
                image4: 'Imatge addicional 4',
                image5: 'Imatge addicional 5',
                banner_image: 'Logotip de promoció',
                locationPageImage: "Imatge de la pàgina d'ubicació",
                displayOnChargeLocation: "Pantalla d'ubicació de recàrrega",
                promotion_button_text: 'Text del botó de promoció',
            },
            label: {
                name: 'Nom',
                company: 'Empresa',
                description: 'Descripció',
                start_date: "Data d'inici",
                expiry_date: 'Data de caducitat',
                offer_duration: "Duració de l'oferta (minuts)",
                stored_for_future_use_days: 'Guardar per a ús futur (dies)',
                always_display_on_partner_promotion: 'Mostrar sempre la promoció de socis',
                qr_code_details: 'Codí QR',
                certificate: 'Certificat',
                image: 'Oferir imatge',
                banner_image: 'Logotip de promoció (1030 X 430)',
                layout: 'Disseny de pantalla',
                note1: "Tinga en compte que, És necessari esmentar  <strong>##image##</strong> i <strong>##qrcode##</strong> sobre el disseny de pantalla HTML per a reemplaçar els detalls respectius en conseqüència. Es poden afegir imatges addicionals a una maqueta utilitzant el codi ##image0X##, on X pot anar d'1 a 5.",
                qr_code_note:
                    'Tinga en compte que, És necessari esmentar <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> i <strong>##ChargeStationAddress##</strong> sobre el codi QR per a substituir les dades corresponents.',
                locationPageImage: "Imatge de la pàgina d'ubicació",
                displayOnChargeLocation: "Pantalla d'ubicació de recàrrega",
                partner_promotion_display_type: 'Tipus de pantalla de promoció',
                promotion_button_text: 'Text del botó de promoció',
                open_external_url: 'Obrir URL externa',
                external_url: 'URL externa',
                image1: 'Imatge addicional 1',
                image2: 'Imatge addicional 2',
                image3: 'Imatge addicional 3',
                image4: 'Imatge addicional 4',
                image5: 'Imatge addicional 5',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                name: {
                    valid: 'Introduïsca un nom vàlid de promoció',
                    max: 'El nom de la promoció és massa gran',
                },
                description: {
                    max: 'La descripció de la promoció és massa gran',
                },
                offer_duration: {
                    moreThan: " La duració de l'oferta ha de ser superior a 0",
                    max: " La duració de l'oferta no pot ser superior a 60",
                },
                stored_for_future_use_days: {
                    moreThan: "L'emmagatzemat per a ús diari futur ha de ser superior a 0",
                    max: "L'emmagatzemat per a ús diari futur no pot ser superior a 99 dies",
                },
                banner_image: {
                    dimensions: 'El logotip promocional ha de tindre unes dimensions de 1030 X 430',
                },
                image: {
                    fileType: "Poden penjar-se arxius amb extensió '.jpg', '.png', '.svg', '.jpeg",
                    location_page_image: 'La ubicació de la imatge de la pàgina és un camp obligatori',
                },
                certificate: {
                    fileType: "Es poden penjar arxius amb extensió '.crt', '.cer'",
                },
                promotion_button_text: {
                    valid: 'Introduïsca el text vàlid del botó de promoció',
                },
                external_url: {
                    url: 'La URL externa ha de ser una URL vàlida',
                },
            },
        },
        assign: {
            header: 'Estacions de recàrrega',
            headerModal: 'Estació de recàrrega',
            placeholder: {
                name: ' Introduïsca el nom',
                locationName: ' Introduïsca el nom de la ubicació',
                address: 'Adreça',
                tags: 'Seleccionar Etiquetes',
            },
            label: {
                add: 'Afegir',
                name: 'Nom',
                type: 'Tipus',
                address: 'Adreça',
                city: 'Ciutat',
                postcode: 'Codi postal',
                last_updated: 'Data de modificació',
                action: 'Acció',
                delete: 'Suprimir',
            },
            button: {
                delete: 'Suprimir',
            },
            message: {
                deleteConfirmMesage: 'Segur que vols eliminar-la?',
            },
        },
    },
    CPOInterface: {
        title: 'Comptes: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Comptes',
        placeholder: {
            name: 'Nom',
            status: 'Seleccionar estat',
        },
        label: {
            name: 'Nom',
            party_id: 'Identificació de part',
            country_code: 'Codi del país',
            version_url: 'Versió URL',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activat',
            disabled: 'Desactivat',
            locationGroup: 'Ubicació del grup',
            yes: 'Sí',
            no: 'No',
            rfidDriverTokens: 'Compartir només fitxes RFID de conductor',
            vat_type: 'Tipus IVA',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: '##COMPANY_BRAND_NAME## CPO Internacional',
            cpo_type: 'Tipus de CPO',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obtindre credencials',
            performHandshake: "Realitzar l'encaixada de mans",
            reHandshake: 'Re-encaixada de mans',
            generateHandshakeToken: "Genera un testimoni d'encaixada de mans",
            reGenerateHandshakeToken: "Regenera el testimoni d'encaixada",
            changeMutualOCPIVersion: 'Canviar la versió OCPI Mutual',
            handshakeDetails: "Detalls de l'encaixada de mans",
        },
        message: {
            enableConfirmMesage: 'Segur que vols activar-les?',
            disableConfirmMesage:
                "Desactivar aquest CPO aturarà tota la comunicació OCPI, ocultarà les ubicacions de càrrega associades a les aplicacions, marcarà les estacions de càrrega enllaçades com a 'Eliminades' i eliminarà les ubicacions dels grups d'accés. Esteu segur que voleu continuar?",
        },
        insert: {
            header: "Gestió d'operadors de punts de recàrrega",
            placeholder: {
                name: 'Nom',
                party_id: 'Identificació de part',
                country_code: 'Codi del país',
                ocpi: 'EMSP',
                version_url: 'Versió URL del CPO',
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                colour_code: 'Codi color',
                back_office_url: 'URL del back office',
                vat_type: 'Tipus IVA',
                region: 'Seleccionar regió',
                vat: 'Seleccionar IVA',
                cpo_type: 'Tipus de CPO',
            },
            label: {
                name: 'Nom',
                party_id: 'Identificació de part',
                country_code: 'Codi del país',
                ocpi: 'EMSP',
                version_url: 'Versió URL',
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                locationGroup: 'Ubicació del grup',
                rfidDriverTokens: 'Compartir només fitxes RFID de conductor',
                colour_code: 'Codi color',
                back_office_url: 'URL del back office',
                vat_type: 'Tipus IVA',
                disableLocationPatchPutRemovals: "Desactivar les eliminacions PATCH/PUT d'ubicació",
                enableAutoMaxPowerCalculation: 'Activar el càlcul automàtic de la potència màxima',
                mutual_ocpi_version: 'Versió de OCPI Mútua',
                externalCPO: 'Regió associada',
                is_external: '##COMPANY_BRAND_NAME## CPO Internacional',
                defaultVat: 'IVA per defecte (anul·lar)',
                gmbAccountID: 'Identificació de compte de GMB',
                cpo_type: 'Tipus de CPO',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                name: {
                    valid: 'Introduïsca un nom de CPO vàlid',
                },
                party_id: {
                    valid: 'Introduïsca una identificació de Part vàlida',
                },
                country_code: {
                    valid: 'Introduïsca un codi vàlid de pais',
                },
                version_url: {
                    url: 'La URL de la versió ha de ser una URL vàlida',
                },
                colour_code: {
                    valid: 'Introduïsca un codi vàlid de color',
                },
                back_office_url: {
                    url: 'La URL de la Back Office ha de ser una URL vàlida',
                },
            },
        },
        versionEndpoints: {
            header: 'Versió Endpoints',
            label: {
                version: 'Versió',
                identifier: 'Identificar',
                role: 'Paper',
                url: 'URL',
                last_executed: 'Última sincronització executada el',
            },
        },
        modal: {
            message:
                "Vosté està marcant este CPO com ##COMPANY_BRAND_NAME## CPO Internacional, vosté necessita agregar esta ubicació CPO manualment en el grup d'accés públic",
            okButton: 'OK',
        },
        performHandshakeModal: {
            handshakeHeader: 'Realitzar apretat de mans',
            reHandshakeHeader: "Tornar a fer l'apretat de mans",
            label: {
                mutual_ocpi_version: 'Versió OCPI mútua',
                version_url: 'URL de la versió',
                handshake_token: "Token d'apretat de mans",
            },
            placeholder: {
                mutual_ocpi_version: 'Versió OCPI mútua',
                version_url: 'URL de la versió',
                handshake_token: "Token d'apretat de mans",
            },
            button: {
                cancel: 'Cancel·lar',
                generateHandshakeToken: "Generar token d'apretat de mans",
                confirm: 'Confirmar',
                connect: "Connecta't",
                reconnect: 'Torna a connectar',
            },
            confirmationModal: {
                header: 'Realitzar apretat de mans',
                rehandshakeMessage:
                    "Les credencials CPO canviaran després de tornar a fer l'apretat de mans. Estàs segur que vols continuar amb la nova apretat de mans?",
                tokenGeneratedMessage:
                    "El token d'apretat de mans per al CPO ja s'ha generat. Si es dóna el token al CPO i intenta realitzar una apretat de mans amb l'EMSP, podria fallar. Estàs segur que vols continuar amb la nova apretat de mans?",
            },
            cpoAuthTokenMessage: "El valor predeterminat que es mostra aquí és el testimoni d'autenticació CPO",
        },
        generateHandshakeTokenModal: {
            header: "Generar token d'apretat de mans",
            reGenerateTokenHeader: "Tornar a generar token d'apretat de mans",
            label: {
                handshakeToken: "Token d'apretat de mans",
                emsp_auth_token: "Token d'autorització EMSP",
                emspVersionURL: 'URL de la versió EMSP',
            },
            Placeholder: {
                handshakeToken: "Token d'apretat de mans",
                emsp_auth_token: "Token d'autorització EMSP",
            },
            button: {
                save: 'Desar',
                copyToClipboard: 'Copiar al porta-retalls',
                generateToken: 'Generar',
                reGenerateToken: 'Tornar a generar',
                confirm: 'Confirmar',
                cancel: 'Cancel·lar',
            },
            copyToClipboard: {
                success: 'Token copiat al porta-retalls',
                failed: 'Error en copiar el token',
            },
            confirmationModal: {
                confirmationMessage:
                    "Si es dóna l'antic token d'apretat de mans al CPO, podria fallar si el CPO intenta utilitzar-lo per a l'apretat de mans. Estàs segur que vols desar el nou token d'apretat de mans?",
                header: 'Desar token',
            },
            emspAuthTokenMessage: "El valor predeterminat que es mostra aquí és el testimoni d'autenticació EMSP",
        },
        changeMutualOCPIVersionModal: {
            header: 'Canviar versió mútua OCPI',
            label: {
                mutualOCPIVersion: 'Versió mútua OCPI',
            },
            button: {
                save: 'Desar',
                cancel: 'Cancel·lar',
                confirm: 'Confirmar',
            },
            confirmationModal: {
                confirmationMessage: 'Estàs segur que vols actualitzar la versió mútua OCPI?',
            },
        },
        handshakeDetailsModal: {
            header: "Detalls de l'apretat de mans",
            label: {
                version_url: 'URL de la versió',
                handshakeToken: "Token d'apretat de mans",
                emspAuthToken: "Token d'autorització EMSP",
                cpoAuthToken: "Token d'autorització CPO",
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Transferències internes: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Transferències internes',
        transferDetailTitle: 'Detalls de la transferència: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        transferDetailHeader: ' Detalls de la transferència',
        label: {
            transfer_id: 'ID de la transferència',
            gross_value: 'Valor brut',
            created_date: 'Data de creació',
            action: 'Acció',
            transferNumber: 'Número de transferència',
            transferDate: 'Data de transferència',
            transaction: 'ID de Transaccions',
            transactionStartDate: "Data d'inici de la transacció",
            transactionEndDate: 'Data de finalització de la transacció',
            publicCardId: 'Identificació de la targeta pública',
            driverAccountId: 'Identificació del compte de conductors',
            driverName: 'Núm. conductor/vehicle',
            stationId: 'Identificació Estació',
            stationName: 'Nom de la estació',
            stationAddress: 'Adreça de la estació',
            kwh: 'kWh',
            price_per_kwh: 'Preu/kWh',
            disable: 'DESACTIVAT',
        },
        placeholder: {
            start_date: "Data d'inici",
            end_date: 'Data final',
            status: 'Estat',
            cpo: 'Seleccione CPO',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            action: 'Acció',
        },
        errors: {
            cpo: {
                required: 'Per favor, seleccionar CPO',
            },
        },
    },
    PSPSetting: {
        title: 'Proveïdors de servicis de pagament: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Proveïdor de servicis de pagament',
        placeholder: {
            name: 'Nom',
            status: 'Seleccionar estat',
            type: 'Seleccionar tipus',
        },
        label: {
            name: 'Nom',
            code: 'Codí',
            type: 'Tipus',
            description: 'Descripció',
            store_name: 'Botiga',
            department_name: 'Departament',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activat',
            disabled: 'Desactivat',
            details: 'Detalls',
            key: 'Clau',
            value: 'Valor',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obtindre credencials',
            delete: 'Suprimir',
        },
        message: {
            enableConfirmMesage: 'Segur que vols activar-les?',
            disableConfirmMesage: 'Segur que vols desactivar-les?',
        },
        insert: {
            header: 'Gestionar el proveïdor de servicis de pagament',
            placeholder: {
                name: 'Nom',
                type: 'Tipus',
                description: 'Descripció',
                store_name: 'Nom de la botiga',
                store_id: 'Identificació de la botiga',
                merchant_name: 'Nom del comerciant',
                merchant_id: 'Identificació del comerciant',
                department_name: 'Nom del departament',
                department_id: 'Identificació del departament',
                signature_key: 'Clau de firma',
                secret_key: 'Clau secreta',
                user_name: "Nom d'usuari",
                password: 'Contrasenya',
                data: 'Dades',
                category: 'Categoria',
                url: 'URL',
                acquirerId: "Identificació d'adquirent",
                firstName: 'Nom',
                lastName: 'Cognom',
                houseName: 'Nom de la casa',
                postcode: 'Codi postal',
                donationProviderType: 'Tipus de proveïdor de donacions',
                isGiftAid: "És l'ajuda als regals",
                donationStoreId: 'Identificació de la botiga de donacions',
                donationMerchantNumber: 'Nom del comerciant de donacions',
                clientID: 'Identificació del client',
                clientSecret: 'Secret del client',
                terminalID: 'Identificació de terminal',
                enableCardRefunds: 'Activar el reembossament amb targeta',
                enableCardVerification: 'Activar la verificació amb targeta',
                enableCharity: 'Permetre la caritat',
            },
            label: {
                name: 'Nom',
                type: 'Tipus',
                firstName: 'Nom',
                lastName: 'Cognom',
                houseName: 'Nom de la casa',
                postcode: 'Codi postal',
                donationProviderType: 'Tipus de proveïdor de donacions',
                isGiftAid: "És l'ajuda als regals",
                donationStoreId: 'Identificació de la botiga de donacions',
                donationMerchantNumber: 'Nom del comerciant de donacions',
                code: 'Codí',
                description: 'Descripció',
                store_name: 'Nom de la botiga',
                store_id: 'Identificació de la botiga',
                merchant_name: 'Nom del comerciant',
                merchant_id: 'Identificació del comerciant',
                department_name: 'Nom del departament',
                department_id: 'Idenbtificació del departament',
                signature_key: 'Clau de firma',
                secret_key: 'Clau secreta',
                user_name: "Nom d'usuari",
                password: 'Contrasenya',
                data: 'Dades',
                action_urls: 'URLs Acció',
                category: 'Categoria',
                url: 'URL',
                acquirerId: "Identificació d'adquirent",
                clientID: 'Identificació del client',
                clientSecret: 'Secret del client',
                terminalID: 'Identificació de terminal',
                enableCardRefunds: 'Activar el reembossament amb targeta',
                enableCardVerification: 'Activar la verificació amb targeta',
                enableCharity: 'Permetre la caritat',
                mobileMerchantId: 'Identificació del comerciant mòbil',
                mobileMerchantPassword: 'Contrasenya de comerciant mòbil',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                name: {
                    valid: 'Introduïsca un nom vàlid',
                },
                code: {
                    valid: 'Introduïsca un codi vàlid',
                },
                url: {
                    valid: 'La URL ha de ser una URL vàlida',
                },
                DatatransSupportCards: {
                    valid: 'Introduïu un valor vàlid per a les targetes DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'Targetes RFID: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Targeta RFID',
        placeholder: {
            name: 'Nom del conductor /Correu electrònic / Organització',
            manufacturer: 'Fabricant',
            part_id: 'Identificació de part',
            public_card_id: 'Identificació de la targeta pública',
            status: 'Seleccionar estat',
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Assignat a',
            email_vehicle: 'Compte associat',
            manufacturer: 'Fabricant',
            part_id: 'Identificació de part',
            public_card_id: 'Identificació de la targeta pública',
            private_card_id: 'Identificació de la targeta privada',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activat',
            disabled: 'Desactivat',
            delete: 'Suprimir',
            deAllocate: 'Eliminar Associació',
            view: "Veure detall de l'IVA",
            allocateCardToOrganisation: 'Assignar targetes en bloc a una organització',
            mifare_uid: 'UID MIFARE',
            reinstate: 'Restablir la targeta',
            card_type: 'Tipus de targeta',
            removeBulkAssociation: "Eliminar l'associació de targetes RFID en bloc",
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            addBulk: 'Afegir targetes en bloc a la fabricació',
            assing: 'Assignar targeta RFID',
            allocateRFIDCard: 'Adjudicar targeta RFID',
            import: 'Importar fitxer de fabricació',
            export: 'Exportar fitxer de fabricació',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obtindre credencials',
            delete: 'Suprimir',
            deAllocate: 'Eliminar Associació',
            view: 'Veure detall IVA',
            reinstate: 'Restablir la targeta',
            forceCPOUpdate: 'Actualització de la força CPO',
        },
        errors: {
            export: {
                notSeletedCards: "Per favor, seleccione targetes en espera d'exportació",
            },
        },
        message: {
            enableConfirmMesage: 'Segur que vol activar-la?',
            disableConfirmMesage: 'Segur que vol desactivar-la?',
            deleteConfirmMesage: 'Segur que vol eliminar-la?',
            deAllocateConfirmMesage: "Està segur que desitja eliminar l'associació de la targeta RFID a un compte?",
            reinstateConfirmMessage: 'Està segur que desitja restablir la targeta RFID?',
            forceCPOUpdateConfirmMessage: "Estàs segur que vol forçar l'actualització de la fitxa en el sistema CPO?",
        },
        insert: {
            header: 'Targeta RFID',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificació de part',
                public_card_id: 'Identificació de la targeta pública',
                private_card_id: 'Identificació de la targeta privada',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipus de targeta',
            },
            label: {
                manufacturer: 'Fabricant',
                part_id: 'Identificació de part',
                public_card_id: 'Identificació de la targeta pública',
                private_card_id: 'Identificació de la targeta privada',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipus de targeta',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                name: {
                    valid: 'Introduïsca un nom vàlid',
                },
                code: {
                    valid: 'Introduïsca un codi vàlid',
                },
                url: {
                    valid: 'La URL ha de ser una URL vàlida',
                },
            },
        },
        bulkCards: {
            header: 'Afegir targetes en bloc',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificació de part',
                no_of_cards: '100 Targetes',
                cardType: 'Seleccionar tipus de targeta',
            },
            label: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificació de part',
                no_of_cards: 'Núm. de targetes',
                cardType: 'Tipus de targeta',
            },
            button: {
                yes: 'Crear targetes',
                no: 'Cancel·lar',
            },
            errors: {
                no_of_cards: {
                    min: 'El nombre de targetes no pot ser inferior a 1',
                },
            },
        },
        assignCards: {
            header: 'Assignar targeta RFID',
            header2: 'Ha seleccionat X targetes.',
            selectedCard: 'Ha seleccionat 1 targeta.',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificació de part',
                no_of_cards: '100 Targetes',
            },
            label: {
                driver: 'Conductor',
                organisation: 'Organització',
                no_of_cards: 'Núm. de targetes',
            },
            button: {
                yes: 'Asignar',
                no: 'Cancel·lar',
            },
            form: {
                type: {
                    driver: 'Conductor',
                    organisation: 'Organització',
                },
                driver: 'Conductor',
                organisation: 'Organització',
                placeholder: {
                    driver: 'Seleccionar conductor',
                    organisation: 'Seleccionar Organització',
                },
            },
            errors: {
                notSeletedCards: 'Per favor, seleccione les targetes disponibles',
            },
        },
        disableCards: {
            header: 'Desactivar',
            header2: 'Segur que vols desactivar-les?',
            placeholder: {
                comment: 'Introduïsca un comentari',
            },
            label: {
                comment: 'Comentari',
            },
            button: {
                yes: 'Sí',
                no: 'No',
            },
        },
        allocateCards: {
            header: 'Adjudicar targetes RFID',
            placeholder: {
                file: 'Seleccionar arxiu CSV',
                selectOrganisation: 'Seleccionar Organització',
            },
            label: {
                file: 'Arxiu CSV',
                organisation: 'Organització',
                mifareUID: 'MifareÂ UID',
                publicCardID: 'Identificació de la targeta pública',
                clickHere: 'Polse ací',
                downloadTemplate: 'per a descarregar plantilla',
            },
            button: {
                allocate: 'Assignar',
                cancel: 'Cancel·lar',
            },
            errors: {
                file: {
                    fileType: "Es poden penjar arxius amb extensió'.csv'.",
                },
            },
        },
        removeAssociation: {
            header: "Eliminar l'associació de targetes RFID en bloc",
            placeholder: {
                file: 'Seleccionar arxiu CSV',
            },
            label: {
                file: 'Arxiu CSV',
                clickHere: 'Polse ací',
                downloadTemplate: 'per a descarregar plantilla',
            },
            button: {
                save: 'Guardar',
                cancel: 'Cancel·lar',
            },
            errors: {
                file: {
                    fileType: "Es poden penjar arxius amb extensió'.csv'.",
                },
                maxRFIDRecordsReached:
                    "L'arxiu CSV que ha penjat ha aconseguit el número màxim de 10.000 registres d'identificació de la targeta pública de la targeta RFID. Per favor, reduïsca els registres d'identificació de la targeta pública de la targeta RFID en l'arxiu csv.",
            },
        },
        importCards: {
            header: 'Importar targetes RFID',
            placeholder: {
                file: 'Seleccionar arxiu CSV',
            },
            label: {
                file: 'Arxiu CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancel·lar',
            },
            errors: {
                file: {
                    fileType: "Es poden penjar arxius amb extensió'.csv'.",
                },
            },
        },
        importCardsDetails: {
            header: 'Detalls d’importació de targetes RFID',
            label: {
                unSuccessfullImport: 'Les targetes següents no es poden importar',
                successfullImport: 'Les targetes següents s’han importat correctament',
                failerReason: 'Motiu de la fallada',
                publicCardId: 'ID de targeta pública',
            },
            message: {
                defualtErrorMessage: 'Hi ha un problema a l’hora d’importar les targetes següents.',
            },
        },
        rfidDetails: {
            label: {
                event_date: "Data de l'esdeveniment",
                chargeLocation: 'Ubicació de la recàrrega',
                charge_station_name: 'Nom de la estació',
                response_status: 'Estat de la resposta',
            },
        },
    },
    referralPromotion: {
        title: 'Promoció per recomanació: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Promoció per recomanació',
        manageReferralPromotion: 'Gestionar promoció per recomanació:',
        label: {
            name: 'Nom',
            code: 'Codí',
            minCharge: 'Recàrrega mínima',
            maxLimit: 'Límit màxim',
            maxRefreeLimit: 'Límit màxim de mediador',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            disabled: 'Desactivat',
            enabled: 'Activat',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            promotionCode: 'Codi de Promocions',
            description: 'Descripció',
            maxReferralLimit: 'Límit màxim de remissió',
            minChargeValue: 'Valor mínim de la recàrrega',
            refereeBonus: 'Bonificació de mediador',
            referrerBonus: 'Bonificació de mediador',
        },
        button: {
            search: 'Buscar',
            back: 'Tornar',
            add: 'Afegir',
            reset: 'Restablir',
            edit: 'Editar',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            action: 'Acció',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            enableConfirmMesage: 'Segur que vol activar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
        },
        placeholder: {
            name: 'Nom',
            code: 'Codí',
            selectPromotion: 'Seleccione promoció',
            selectStatus: 'Seleccionar estat',
            promotionCode: 'Codi de Promocions',
            description: 'Descripció',
            maxReferralLimit: 'Límit màxim de remissió',
            minChargeValue: 'Valor mínim de la recàrrega',
            refereeBonus: 'Bonificació de mediador',
            referrerBonus: 'Bonificació de mediador',
        },
        errors: {
            name: {
                valid: 'Introduïsca un nom vàlid de promoció',
            },
            promotionCode: {
                valid: 'Introduïsca un codi vàlid de promoció',
            },
            maxReferralLimit: {
                moreThan: 'El límit màxim de remissió ha de ser superior a zero',
            },
            referrerBonus: {
                max: 'El valor del Bo per a Referidor no pot ser superior a ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'El valor del Bo per a Referit no pot ser superior a ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Condicions generals: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Condicions generals',
        manageTermsConditions: 'Condicions generals',
        label: {
            enabled: 'Activat',
            disabled: 'Desactivat',
            name: 'Nom',
            description: 'Descripció',
            apply_to: 'Aplicar a',
            mandatory_for_user: "Obligatori per a l'usuari",
            status: 'Estat',
            delete: 'Suprimir',
            content: 'Contingut de la política',
            yes: 'Sí',
            no: 'No',
            draft: 'Esborrany',
            published: 'Publicat en',
        },
        placeholder: {
            name: 'Nom',
            description: 'Descripció',
            select: {
                apply_to: 'Aplicar a',
                status: 'Seleccionar estat',
            },
        },
        columns: {
            name: 'Nom',
            description: 'Descripció',
            applyto: 'Aplicar a',
            mandatory_for_user: 'Obligatori',
            status: 'Estat',
            action: 'Acció',
            modified_date: 'Modificat el',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            add: 'Afegir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
        },
        errors: {
            name: {
                valid: 'Introduïsca un nom vàlid',
            },
            invalidFormat: "Per favor, penge un format d'imatge vàlid",
            common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
        },
        message: {
            deleteConfirmMesage: 'Segur que vols eliminar-ho?',
        },
    },
    rewardPromotion: {
        title: 'Promocions amb recompensa: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'IV Promocions de recompensa',
        manageRewardPromotion: 'Gestionar IV Promocions de recompensa',
        label: {
            name: 'Nom',
            code: 'Codi',
            valuesPerkwh: 'Valors per kWh',
            monetoryValue: 'Valor monetari',
            redemptionBlock: "Bloc d'amortització",
            createdDate: 'Data de creació',
            status: 'Estat',
            enabled: 'Activat',
            disabled: 'Desactivat',
            action: 'Acció',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            promotionCode: 'Codi de Promocions',
            description: 'Descripció',
            expired: 'Caducat',
            locationApplicable: 'Ubicació de la càrrega aplicable',
            voltsPerkwh: 'Volts per kWh',
            confirmation: 'Confirmació',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Suprimir',
            enable: 'Activar',
            disable: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-ho?',
            enableConfirmMesage: 'Segur que vol activar-ho?',
            disableConfirmMesage: 'Segur que vol desactivar-ho?',
            uncheckConfirmMesage:
                "En desmarcar esta casella, s'eliminaran totes les ubicacions de càrrec associades a esta promoció. Segur que vols eliminar-la?",
        },
        placeholder: {
            name: 'Nom',
            code: 'Codi',
            selectPromotion: 'Seleccione estat',
            selectStatus: 'Seleccionar estat',
            locationApplicable: 'Ubicació de la càrrega aplicable',
            voltsPerkwh: 'Volts per kWh',
        },
        errors: {
            name: {
                valid: 'Introduïsca un nom vàlid de promoció',
            },
            promotionCode: {
                valid: 'Introduïsca un codi vàlid de promoció',
            },
            monetoryValue: {
                moreThan: 'El valor monetari ha de ser superior a zero',
                lessThan: 'El valor monetari ha de ser inferior o igual a 99999,99',
                typeError: 'Introduïsca un valor monetari vàlid',
            },
            redemptionPointBlock: {
                moreThan: "El Bloc d'amortització ha de ser superior a zero",
            },
            valuePerKwh: {
                moreThan: 'El valor ha de ser superior a zero',
            },
        },
    },
    amenitys: {
        title: 'Servicis: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Servicis',
        manageamenitys: 'Gestionar servicis',
        chargeStationsList: 'Estacions de recàrrega',
        chargeLocation: 'Ubicacions de la recàrrega',
        amenityTranslationNote:
            "Per favor, introduïsca els detalls de les comoditats per als usuaris administradors / conductors en l'idioma respectiu de la regió. Si no s'han introduït dades per a un idioma concret, el sistema mostrarà les dades per defecte.",
        label: {
            enabled: 'Activat',
            disabled: 'Desactivat',
            name: 'Nom',
            imageUpload: 'Icona (34 X 34)',
            language: 'Idioma',
            image: 'Icona',
            description: 'Descripció',
            default_search: 'Cerca per defecte',
            status: 'Estat',
            delete: 'Suprimir',
            csvFile: 'Arxiu CSV',
            importAmenityHeader: 'Importar servicis',
            chargeLocation: {
                name: 'Nom',
                type: 'Tipus',
                address: 'Adreça',
                city: 'Ciutat',
                postal_code: 'Codi postal',
                modifiedDate: 'Data de modificació',
                action: 'Acció',
            },
            charge_station_name: 'Charge_Station_Name',
            charge_point: 'Charge_Point',
            charge_location_name: 'Charge_Location_Name',
            latitude: 'Latitud',
            longitude: 'Longitud',
            location_address: 'Location_Address',
            amenities: 'Servicis',
            amenity_type: 'Tipus de servicis',
        },
        placeholder: {
            name: 'Nom',
            description: 'Descripció',
            file: 'Seleccionar arxiu CSV',
            select: {
                status: 'Seleccionar estat',
                amenity_type: 'Seleccionar tipus',
            },
        },
        columns: {
            name: 'Nom',
            description: 'Descripció',
            status: 'Estat',
            action: 'Acció',
            amenity_type: 'Tipus',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            add: 'Afegir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            disable: 'Desactivar',
            enable: 'Activar',
            import: 'Importar',
        },
        errors: {
            common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
            name: {
                valid: 'Per favor, introduïsca un nom vàlid.',
            },
            image: {
                fileType: "Poden penjar-se arxius amb extensió '.jpg', '.png', '.svg', '.jpeg",
                dimensions: 'La icona ha de tindre una dimensió de 34 X 34',
                required: 'La icona és un camp obligatori',
            },
        },
        message: {
            deleteConfirmMesage: 'Segur que vols eliminar-la?',
            enableConfirmMesage: 'Segur que vols activar-la?',
            disableConfirmMesage: 'Segur que vols desactivar-la?',
        },
    },
    vehicle: {
        title: 'Vehicle: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Vehicles',
        columns: {
            name: 'Nom',
            registerNo: 'Número de registre',
            make: 'Fer',
            model: 'Model',
            chargeType: 'Tipus de recàrrega',
            batteryCapacity: 'Capacitat de la bateria',
            consumption: 'Consum',
        },
        placeholder: {
            nameEmail: 'Nom / Correu electrònic',
            makeModelRegistrationNo: 'Fer / Model / Número de registre',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
        },
    },
    incompleteSessions: {
        title: 'Sessions incompletes: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Sessions incompletes',
        placeholder: {
            nameOrEmail: 'Nom / Correu electrònic',
            locationOrStation: 'Ubicació / Estació',
            startDate: "Data d'inici",
            endDate: 'Data final',
            status: 'Seleccionar estat',
            comment: 'Introduïsca els seus comentaris',
        },
        label: {
            invalid: 'No vàlid',
            generateCDR: 'Generar CDR',
            totalEnergy: 'Energia total',
            totalCost: 'Cost total',
            comment: 'Introduïsca els seus comentaris',
            cancelCDR: 'Cancel·lar CDR',
        },
        columns: {
            name: 'Nom',
            location: 'Ubicació',
            sessionId: 'Identificació de sessió',
            startDate: "Data d'inici",
            modifiedDate: 'Data de modificació',
            time: 'Temps',
            energy: 'Energia </br> (kWh)',
            cost: 'Cost',
            status: 'Estat',
            action: 'Acció',
        },
        button: {
            action: 'Acció',
            generateCDR: 'Generar CDR',
            search: 'Buscar',
            reset: 'Restablir',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
            cancelCDR: 'Cancel·lar CDR',
        },
        error: {
            max: 'Màxim 250 caràcters permesos',
        },
        message: {
            cancelCDRMessage: 'Està segur que vol cancel·lar la sessió?',
            cancelBulkCDRMessage: 'Està segur que desitja cancel·lar la sessió per als registres seleccionats?',
            selectCDR: 'Per favor, seleccione les sessions incompletes',
        },
    },
    ocpiSessions: {
        title: 'Sessions OCPI: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Sessions',
        placeholder: {
            nameOrEmail: 'Nom / Correu electrònic',
            locationOrStation: 'Ubicació / Estació',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            status: 'Seleccionar estat',
            comment: 'Introduïsca els seus comentaris',
        },
        columns: {
            name: 'Nom',
            location: 'Ubicació',
            sessionId: ' Identificació de sessió',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            time: 'Temps',
            energy: 'Energia </br> (kWh)',
            cost: 'Cost',
            status: 'Estat',
            action: 'Acció',
            vehicleNumber: 'Número de vehicle',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            complete: 'Completat',
        },
        label: {
            complete: 'Completat',
            completeSessions: 'Sessions de càrrega completes',
        },
        message: {
            completeConfirmMessage: 'Desitja completar la sessió de recàrrega?',
            stopBulkSessionsMessage: 'Desitja completar la sessió de recàrrega seleccionada?',
            selectSession: 'Per favor, seleccione les sessions de recàrrega',
        },
    },
    organisation: {
        title: 'Gestionar organització: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Organització',
        manageOrganisation: 'Gestionar organització',
        label: {
            name: 'Nom',
            description: 'Descripció',
            address: 'Adreça',
            city: 'Ciutat',
            county: 'Província',
            postal_code: 'Codi postal',
            contact_person: 'Persona de contacte',
            email: 'Correu electrònic',
            phone_number: 'Núm. de Telèfon',
            payment_mode: 'Forma de pagament',
            payment_schedule: 'Calendari de Pagament',
            user_group_ids: "Grups d'usuari",
            enabled: 'Activat',
            disabled: 'Desactivat',
            amount: 'Límit de crèdit',
            po_number: 'Número de comanda',
            finance_account_number: 'Número de compte financer',
            account_contact_email: 'Correu electrònic de contacte del compte',
            remaining_credit: 'Crèdit restant (%)',
            remoteChargePassword: 'Inicie contrasenya recàrrega remota',
            is_deleted: 'Es suprimix',
            yes: 'Sí',
            deleted: 'Suprimit',
            dailySpendLimit: 'Límit de despesa diària',
            weeklySpendLimit: 'Límit de despesa setmanal',
            monthlySpendLimit: 'Límit de despesa mensual',
            defaultSpendLimitGroup: 'Grup de límit de despeses per defecte',
            updateSpendLimitAssociation: 'Associació Grup Límit de Despesa',
            promotionUpdate: 'Actualització Promocions',
            currentPromotion: 'Promoció actual',
            newPromotion: 'Nova promoció',
        },
        placeholder: {
            name: 'Nom',
            name_or_email_or_contact_person: 'Nom/Persona de contacte/Correu electrònic',
            description: 'Descripció',
            address: 'Adreça',
            city: 'Ciutat',
            county: 'Província',
            postal_code: 'Codi postal',
            contact_person: 'Persona de contacte',
            email: 'Correu electrònic',
            phone_number: 'Núm. de Telèfon',
            select: {
                status: "Seleccione l'estat",
                payment_mode: 'Seleccione la Forma de Pagament',
                payment_schedule: 'Seleccione el Calendari de Pagament',
                user_group_ids: "Seleccione els Grups d'usuari",
            },
            amount: 'Límit de crèdit',
            po_number: 'Número de comanda',
            finance_account_number: 'Número de compte financer',
            remaining_credit: 'Crèdit restant (%)',
            remoteChargePassword: 'Inicie contrasenya recàrrega remota',
            enableSpendLimit: 'Activar Límit de despesa',
            defaultSpendLimitGroup: 'Seleccionar Grup de límit de despeses per defecte',
            selectCurrentPromotion: 'Seleccionar Promoció actual',
            selectNewPromotion: 'Seleccione nova promoció',
        },
        columns: {
            name: 'Nom',
            contact_Person: 'Persona de contacte',
            email: 'Correu electrònic',
            payment_mode: 'Forma de pagament',
            payment_schedule: 'Calendari de Pagament',
            created_date: 'Creat el',
            status: 'Estat',
            action: 'Acció',
            remote_charge_password: 'Inicie contrasenya recàrrega remota',
            promotion: 'Promoció',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            add: 'Afegir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            enable: 'Activar',
            disable: 'Desactivar',
            permission: 'Permís API',
            assignSpendLimitGroup: 'Assignar grup de límit de despeses',
        },
        errors: {
            name: {
                valid: 'Per favor, introduïsca un nom vàlid',
            },
            contact_person: {
                valid: 'Per favor, introduïsca una persona de contacte vàlida',
            },
            email: {
                required: "Per favor, introduïsca l'adreça de correu electrònic",
                email: 'Per favor, introduïsca una adreça de correu electrònic vàlida',
            },
            phoneNo: {
                required: 'Per favor, introduïsca un número de telèfon',
                match: 'Per favor, introduïsca un número de telèfon vàlid',
            },
            amount: {
                moreThan: "L'import ha de ser major que 0",
                maxcredit: "Límit màxim aconseguit per a l'abonament en compte",
            },
            po_number: {
                valid: 'Per favor, introduïsca, introduïsca un número de comanda vàlida',
            },
            finance_account_number: {
                valid: 'Per favor, introduïsca un número de compte financer vàlid',
            },
            account_contact_email: {
                required: 'Per favor, introduïsca almenys una adreça de correu electrònic',
                maxLimit: 'Límit màxim aconseguit per al correu electrònic de contacte del compte',
            },
            remaining_credit: {
                match: 'Per favor, introduïsca el crèdit restant vàlid',
                maxCredit: 'El valor màxim dels crèdits restants no ha de superar els 100',
                minCredit: 'El valor mínim del crèdit restant no ha de ser inferior a 0',
            },
            value: {
                moreThan: 'El valor ha de ser major que 0',
                lessThan: 'El valor debe ser inferior o igual a 5000',
                number: 'El valor ha de ser un número',
                lessThanWeekly: 'El valor ha de ser inferior o igual al límit de despesa setmanal',
                lessThanMonthly: 'El valor ha de ser inferior o igual al límit de despesa mensual',
            },
            spend_limit: {
                moreThan: 'El límit de despesa setmanal ha de ser superior al límit de despesa diària',
                lessThan: 'El límit de despesa diària ha de ser superior al límit de despesa setnanal',
            },
            address: 'es permet un màxim de 10 caràcters',
            addressValid: 'Per favor, introduïsca una adreça vàlida',
            user_group: {
                required: "Per favor, seleccione almenys un grup d'usuaris",
            },
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            enableConfirmMesage: 'Segur que vol activar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
            assignAllDriversToDefaultGroup:
                "Desitja assignar tots els conductors d'esta organització al grup de límit de despeses per defecte?",
            updatePromotionConfirmMessage:
                'Està segur que desitja actualitzar les promocions de les organitzacions seleccionades?',
            selectOneRecord: 'Seleccione almenys un conductor/vehicle',
            promotionAssignMessage: "La nova promoció s'assignarà a les següents organitzacions:",
        },
        permission: {
            header: 'Permís API',
            label: {
                description: 'Descripció',
                action: 'APIs',
            },
        },
    },
    transactionLogs: {
        title: 'Registres de transaccions: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Registres de transaccions',
        placeholder: {
            page: 'Seleccionar pàgina',
            email: 'Adreça de correu electrònic',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            fieldName: 'Nom del camp',
            content: 'Contingut',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
        },
        label: {
            tableName: 'Nom de la taula',
            fieldName: 'Nom del camp',
            oldValue: 'Valor antic',
            newValue: 'Valor nou',
            user: 'Usuari',
            logDate: 'Data de registre',
            action: 'Acció',
            goToPage: 'Anar a la pàgina',
        },
    },
    organisationAccountBalance: {
        title: "Saldo del compte de l'organització: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
        header: "Saldo del compte de l'organització",
        manageUser: "Gestionar saldo del compte de l'organització",
        columns: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crèdit disponible',
            unbilledAmount: 'Import no facturat',
            name: 'Nom',
            contact_Person: 'Persona de contacte',
            email: 'Correu electrònic',
            payment_mode: 'Forma de pagament',
            payment_schedule: 'Calendari de Pagament',
            balance: 'Saldo',
            status: 'Estat',
            action: 'Acció',
            refund: 'Modificar el saldo del compte',
        },
        placeholder: {
            name: 'Nom/Persona de contacte/Correu electrònic',
            description: 'Comentari',
            amount: "Introduïsca l'import a abonar o deure",
            select: {
                status: 'Seleccionar estat',
                payment_mode: 'Forma de pagament',
                payment_schedule: 'Calendari de Pagament',
            },
            invoice: 'Seleccionar factura',
        },
        label: {
            description: 'Comentari',
            amount: "Introduïsca l'import a abonar o deure",
            payment_settlement: 'Modificació del saldo - Sol·licitud',
            enabled: 'Activat',
            disabled: 'Desactivat',
            invoice: 'Factura',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            save: 'Guardar',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            action: 'Acció',
            send_for_approval: 'Enviar per a aprovació',
            accept: 'Acceptar',
        },
        errors: {
            amount: {
                moreThan: "L'import ha de ser major/menor que 0",
                maxcredit: "Límit màxim aconseguit per a l'abonament en compte",
                maxdebit: 'Límit màxim de deute en compte aconseguit',
            },
        },
    },
    driverAward: {
        rewardTitle:
            'Saldo de recompenses - ##COMPANY_BRAND_NAME## Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        approvalRequest:
            'Aprovació de saldos de recompenses - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        rewards: 'Saldo de recompenses',
        approvalRequests: 'Aprovació de saldos de recompenses',
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            iVRewardPromotion: 'IV Promoció de recompensa',
            balance: 'Saldo',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activat',
            disabled: 'Desactivat',
            location: 'Ubicació',
            date: 'Data',
            energy: 'Energia (kWh)',
            cost: 'Cost',
            rewardPoint: 'Punt de recompensa',
            rewardSettelemant: 'Canviar la recompensa',
            description: 'Descripció',
            credit: 'Crèdit',
            debit: 'Dèbit',
            iVRewardSettelemant: 'Recompenses - Canviar-les',
            amount: 'Import',
            request_by: 'Sol·licitat per',
            request_date: "Sol·licitat el/l'",
            review_by: 'Revisat per',
            review_date: 'Revisat el',
            review_comment: 'Revisar Comentaris',
            approvalRequest: "Sol·licitud d'aprovació",
            enterComments: 'Introduïsca els seus comentaris',
            transaction_date: 'Data de transaccions',
            debit_credit: 'Dèbit/Crèdit',
            type: 'Tipus',
            requested_by_comment: 'Sol·licitat per Comentaris',
            volts: 'Volts',
            commentsFrom: 'Comentaris de',
            approve: 'Aprovar',
            decline: 'Rebutjar',
            federatedAccount: 'Tipus de compte federat',
        },
        placeholder: {
            nameOrEmail: 'Nom/Correu electrònic',
            selectIVAwardPromotion: 'Seleccione IV Promoció de Premi',
            selectStatus: 'Seleccionar estat',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            description: 'Descripció',
            volts: 'Volts',
            enterComments: 'Introduïsca els seus comentaris',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            decline: 'Rebutjar',
            approve: 'Aprovar',
            send_for_approval: 'Enviar per a aprovació',
        },
        errors: {
            type: {
                required: 'Abonament o deute de la liquidació',
            },
            volts: {
                typeError: 'Introduïsca volts vàlids',
                moreThan: 'Els volts han de ser major/menor que 0',
            },
            status: {
                selectApprovalOrReject: 'Aprove o rebutge esta sol·licitud.',
            },
        },
    },
    organisationdashboard: {
        title: "Quadre de comandament de l'organització: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
        header: "Quadre de comandament de l'organització",
        dashboard: 'Quadre de comandaments',
        label: {
            filter: 'Filtre',
            organisation: 'Organització',
            selectOrganisations: 'Seleccionar Organització',
            dateRange: 'Interval de dates',
            driverGroup: 'Grups de conductors',
            drivers: 'Conductor/vehicle',
            selectDriver: 'Seleccionar conductor/vehicle',
            selectDriverGroup: 'Seleccionar Grups de conductors',
            month: 'Mes',
            year: 'Any',
            day: 'Dia',
            week: 'Setmana',
            userSessionTitle: 'Sessions de conductors',
            userSessions: 'Sessions de conductors',
            totalIncomeTitle: "Suma d'ingressos",
            income: 'Ingresos',
            energy: 'Energia',
            energyTitle: "Suma d'energia (kWh)",
            selectAll: 'Seleccionar tot',
            totalRFIDCards: 'Total targetes RFID',
            available: 'Disponible',
            allocated: 'Assignat',
            duplicate: 'Duplicar',
            disabled: 'Desactivat',
            rfid: 'RFID',
            totalDriverAccounts: 'Total de comptes de conductors',
            driver: 'Conductors',
            enabled: 'Activat',
            pending: 'Pendent',
            deleted: 'Suprimit',
            topTenDriverVehicles: 'Els 10 conductors/vehicles més utilitzats',
            driverAccount: 'Conductor',
            vehicle: 'Vehicle',
            driverName: 'Nom del conductor',
            vehicleNumber: 'Número de vehicle',
            kwhUsage: 'Consum de kWh',
            dateRangeLabel: 'Interval de dates:',
            both: 'Tots dos',
            nameorvehicleno: 'Nom/Núm. de vehicle',
            type: 'Tipus',
        },
        button: {
            apply: 'Sol·licitar',
            clear: 'Esborrar',
            syncData: 'Sincronitzar dades',
            search: 'Buscar',
            reset: 'Restablir',
        },
    },
    organisationtransactions: {
        headerTitle:
            "Transaccions d'Organització - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit",
        invoiceHeader:
            'Detall de la factura- ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        invoiceTitle: 'Detall de la factura',
        title: "Transaccions d'Organització",
        transaction: 'Transacció',
        columns: {
            location: 'Ubicació',
            date: 'Data',
            time: 'Temps',
            cost: 'Cost',
            energy: 'Energia',
            action: 'Acció',
            remark: 'Observacions',
            amount: 'Import',
            closing: 'Tancant',
            transaction: 'ID de Transaccions',
            name: 'Nom',
            credit: 'Crèdit',
            debit: 'Dèbit',
            vehicleNumber: 'Número de vehicle',
            invoiceNumber: 'Número de factura',
            comment: 'Comentari',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        form: {
            charge: 'Carregant',
            payment: 'Pagament',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exportar tot',
            amount: 'Import',
            driverName: 'Núm. conductor/vehicle',
            station: 'Estació',
            kwh: 'kWh',
            price_per_kwh: 'Preu/kWh',
            net_value: 'Valor net',
            vat_rate: 'Taxa IVA',
            gross_value: 'Valor brut',
            totalBeforeVAT: "Total abans de l'IVA",
            VatAt: ' IVA a',
            VatRate: "Taxa de l'IVA:",
            totalNetAmount: 'Import total net',
            subTotal: 'Sub total',
            adjustedAmount: 'Import ajustat',
            grandTotal: 'Total gran',
            totalFee: 'Taxa total',
            invoiceNumber: 'Número de factura',
            invoiceDate: 'Data de factura',
            transaction: 'ID de Transaccions',
            name: 'Nom',
            date: 'Data',
            publicCardId: 'Identificació de la targeta pública',
            stationId: 'Identificació Estació',
            transactionStartDate: "Data d'inici de la transacció",
            transactionEndDate: 'Data de finalització de la transacció',
            stationAddress: 'Adreça de la estació',
            driverAccountId: 'Identificació del compte de conductors',
            vat_amount: 'Import IVA',
            stationName: "Nom de l'estació",
            status: 'Estat',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            back: 'Tornar',
            export: 'Exportar',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            startDateFrom: "Data d'inici des de",
            startDateTo: "Data d'inici fins a",
            select: {
                organisation: 'Seleccionar Organització',
                invoice: 'Seleccione el número de factura',
            },
        },
        message: {
            noDataToExport: 'No hi ha dades que exportar.',
            organisation: {
                required: 'Per favor, seleccione una organització',
            },
            selectRecordToExport: 'Seleccione els registres a exportar.',
        },
    },
    driverVehicleAccount: {
        title: 'Comptes de conductors/vehicle: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Comptes de conductor/vehicle',
        managedriver: 'Gestionar conductor/vehicle',
        importHeader: 'Penjar nous comptes amb targetes RFID',
        importUpdateStatusHeader: 'Activar desactivar comptes',
        importUpdateSpendGroupAssociation: "Actualització del límit de despesa de l'associació de Grups de conductors",
        placeholder: {
            name: 'Nom / Correu electrònic / Núm. Vehicle',
            rfidCardNo: 'Núm. Targeta RFID',
            driverGroups: 'Seleccionar Grups de conductors',
            status: 'Seleccionar estat',
            first_name: 'Nom',
            last_name: 'Cognom(s)',
            email: 'Adreça de correu electrònic',
            vehicle_no: 'Núm. vehicle',
            driverGroup: 'Seleccionar Grups de conductors',
            accountType: 'Seleccione el tipus de compte',
            publicRFIDCardNo: 'Introduïsca el número de targeta RFID pública.',
            languagePreference: 'Preferència lingüística',
        },
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            vehicleNo: 'Núm. vehicle',
            group: 'Grup',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activat',
            disabled: 'Desactivat',
            cancelled: 'Cancel·lat',
            deleted: 'Suprimit',
            delete: 'Suprimir',
            first_name: 'Nom',
            last_name: 'Cognom',
            vehicle_no: 'Núm. vehicle',
            driverGroup: 'Grups de conductors',
            accountType: 'Tipus de compte',
            assignRFIDCard: 'Assignar targeta RFID',
            rfidCard: 'Targeta RFID',
            publicRFIDCardNo: 'Introduïsca el número de targeta RFID pública.',
            assign: 'Assignar',
            allocatedRFIDCards: 'Targetes RFID assignades',
            file: 'Arxiu CSV',
            clickHere: 'Polse ací',
            downloadTemplate: 'per a descarregar plantilla',
            errosInImportedFile: 'Errors',
            driverVehicleNo: 'Núm. conductor/vehicle',
            driverVehicleDetails: 'Detalls del conductor/vehicle',
            error: 'Error',
            pending: 'Pendent',
            card_allocated: 'Targeta RFID assignada',
            driver: 'Conductor (compte basat en Fleet App)',
            vehicle: 'Vehículo (compte basat en RFID)',
            note: 'Nota: ',
            accountSetupNote:
                "El titular del compte haurà de completar la configuració del compte en un termini de 24 hores a través de l'aplicació per a flotes ##COMPANY_BRAND_NAME## utilitzant la contrasenya temporal proporcionada per correu electrònic.",
        },
        button: {
            import: 'Importar',
            add: 'Afegir',
            search: 'Buscar',
            reset: 'Restablir',
            edit: 'Editar',
            enable: 'Activar',
            disable: 'Desactivar',
            delete: 'Suprimir',
            yes: 'Sí',
            no: 'No',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            assignRFIDCard: 'Assignar targeta RFID',
            assign: 'Assignar',
            action: 'Acció',
            done: 'Fet',
            sendEmail: 'Enviar un correu electrònic',
            enableDisableAccounts: 'Activar desactivar comptes',
            export: 'Exportar',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            enableConfirmMesage: 'Segur que vol activar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
            sendMailConfirmMessage: 'Segur que vol enviar un correu electrònic?',
            mailSentSuccessMessage: 'Correu electrònic enviat correctament.',
        },
        errors: {
            invalidEmail: 'Introduïsca una adreça de correu electrònic vàlida.',
            invalidFirstName: 'Per favor, introduïsca un nom vàlid',
            invalidLastName: 'Per favor, introduïsca un cognom vàlid',
            invalidVehicleNo: 'Per favor, introduïsca un núm. de vehicle vàlid',
            common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
        },
        account_type: {
            driver: 'Conductor',
            vehicle: 'Vehicle',
        },
        columns: {
            public_rfid_card_no: 'Núm. de targeta',
            allocatedBy: 'Assignat a',
            allocatedDate: 'Data assignada',
            status: 'Estat',
        },
    },
    chargingHistory: {
        header: 'Sessions de Recàrrega - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Sessions de Recàrrega',
        label: {
            exportAll: 'Exportar',
            location: 'Ubicació',
            date: 'Data',
            milesAdded: 'Milles afegides',
            time: 'Temps',
            cost: 'Cost',
            energy: 'Energia',
            action: 'Acció',
            remark: 'Observacions',
            name: 'Nom',
            vehicleNo: 'Núm. vehicle',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            back: 'Tornar',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            startDateFrom: "Data d'inici des de",
            startDateTo: "Data d'inici fins a",
            driver: 'Nom / Correu electrònic / Núm. vehicle',
            selectDriverGroup: 'Seleccionar grups de conductor/vehicle',
        },
        errors: {
            noDataToExport: 'No hi ha dades per exportar.',
            selectRecordToExport: 'Seleccione els registres per exportar.',
            common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
        },
    },
    paymentHistory: {
        header: 'Historial de pagaments - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Historial de pagaments',
        invoiceHeader:
            'Detall de la factura- ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        invoiceTitle: 'Detall de la factura',
        label: {
            remark: 'Observacions',
            credit: 'Crèdit',
            debit: 'Dèbit',
            closing: 'Tancant',
            transaction: 'ID de Transaccions',
            name: 'Nom',
            date: 'Data',
            amount: 'Import',
            driverName: 'Núm. conductor/vehicle',
            station: 'Estació',
            kwh: 'kWh',
            price_per_kwh: 'Preu/kWh',
            net_value: 'Valor net',
            vat_rate: 'Taxa IVA',
            gross_value: 'Valor brut',
            totalBeforeVAT: "Total abans de l'IVA",
            VatAt: 'IVA a',
            totalFee: 'Taxa total',
            invoiceNumber: 'Número de factura',
            invoiceDate: 'Data de factura',
            publicCardId: 'Identificació de la targeta pública',
            stationId: 'Identificació Estació',
            transactionStartDate: "Data d'inici de la transacció",
            transactionEndDate: 'Data de finalització de la transacció',
            stationAddress: 'Adreça de la estació',
            driverAccountId: 'Identificació del compte de conductors',
            vat_amount: 'Import IVA',
            stationName: "Nom de l'estació",
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            export: 'Exportar',
        },
        errors: {
            noDataToExport: 'No hi ha dades que exportar.',
            selectRecordToExport: 'Seleccione els registres a exportar.',
        },
    },
    configurations: {
        title: 'Configuracions: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Configuracions',
        columns: {
            name: 'Nom',
            value: 'Valor',
            description: 'Descripció',
            system_type: 'Tipus de sistema',
            modifiedBy: 'Modificat per',
            modifiedDate: 'Data de modificació',
            action: 'Acció',
        },
        button: {
            save: 'Guardar',
            cancel: 'Cancel·lar',
            reset: 'Restablir',
            search: 'Buscar',
            action: 'Acció',
            edit: 'Editar',
        },
        note: "AVÍS: Canviar estos paràmatres de configuració pot afectar significativament el rendiment de la plataforma. En cas de dubte, pose's en contacte amb l'administrador del sistema.",
        errors: {
            maxLengthString: 'Per favor, introduïsca un valor amb el màxim',
            maxLengthStringCharacters: 'caràcters',
            maxLengthNUmberCharacters: 'dígits',
            valueBetween: 'Per favor, introduïsca un valor entre',
            valueGraterThen: 'Per favor, introduïsca un valor igual o superior a',
            valueMention: "Indique el valor en l'interval esmentat",
        },
        placeholder: {
            value: 'Introduïsca el valor',
            description: 'Introduir descripció',
            name: 'Nom',
            valueSearch: 'Valor',
            descriptionSearch: 'Descripció',
            referenceCode: 'Codi de referència',
            systemType: 'Seleccionar tipus de sistema',
        },
        label: {
            value: 'Valor',
            dataType: 'Tipus de dades',
            description: 'Descripció',
            system: 'SISTEMA',
            driver: 'CONDUCTOR',
            admin: 'ADMIN',
            referenceCode: 'Codi de referència',
        },
    },
    rfidRequests: {
        title: 'Sol·licituds de targetes RFID - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Sol·licituds de targetes RFID',
        placeholder: {
            nameEmail: 'Nom / Correu electrònic',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            publicCardNo: 'Introduïsca el número de targeta pública',
            enterComments: 'Introduïsca els seus comentaris',
            status: 'Seleccionar estat',
            publicRFIDCardNo: 'Introduïsca el número de targeta RFID pública.',
            scanReqQR: 'Escanege el codi QR imprés en la carta',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            done: 'Fet',
            action: 'Acció',
            assign: 'Asignar',
            downloadPdf: 'Descarregar Sol·licituds en PDF',
            downloadPdfSelected: 'Descarregar PDF per a sol·licituds seleccionades',
            downloadPendingApprovedPdf: 'Descarregar totes les sol·licituds pendents & sol·licituds aprovades en PDF',
        },
        columns: {
            name: 'Nom',
            email: 'Correu electrònic',
            requestedDate: 'Data sol·licitada',
            noofCardReq: 'Núm. de targeta sol·licitada',
            noofCardAllocated: 'Núm. de targeta assignada',
            requestStatus: 'Estat de la sol·licitud',
            status: 'Estat',
            driverStatus: 'Estat del conductor',
            action: 'Acció',
            public_rfid_card_no: 'Núm. de targeta',
            allocatedBy: 'Assignat a',
            allocatedDate: 'Data assignada',
            federated_account_type: 'Tipus de compte federat',
        },
        label: {
            reviewRequest: 'Sol·licitud de revisió',
            assignRFID: 'Targeta RFID',
            processRFIDRequest: 'Sol·licitud de procés',
            noofCardRequested: 'Núm. de targeta sol·licitada',
            noofCardAllocated: 'Núm. de targeta assignada',
            approved: 'Aprovar',
            declined: 'Rebutjar',
            publicCardNo: 'Introduïsca el número de targeta pública',
            enterComments: 'Introduïsca els seus comentaris',
            requestStatus: 'Estat de la sol·licitud',
            assignRFIDCards: 'Assignar targeta RFID',
            publicRFIDCardNo: 'Introduïsca el número de targeta RFID pública.',
            allocatedRFIDCards: 'Targetes RFID assignades',
            address: 'Adreça',
            scanReqQR: 'Escanege el codi QR imprés en la carta',
            name: 'Nom',
            requestId: 'Identificació de la sol·licitud',
            scanHistory: "Historial d'escaneig",
        },
        message: {
            requestProcessed: 'Sol·licitud processada amb èxit',
        },
        errors: {
            approveReject: 'Per favor, aprove o rebutge esta sol·licitud.',
            selectAnyRecord: 'Seleccione almenys un registre per a descarregar el PDF.',
            reqNumTypeError: 'Per favor, introduïsca una identificació de sol·licitud vàlida',
        },
        pdfText: {
            dear: 'Estimat, estimada',
            instavolt: ' ##COMPANY_BRAND_NAME##',
            companyNumber: 'Número de empresa',
            line1: "Gràcies per sol·licitar la seua targeta RFID a través de l'aplicació ##COMPANY_BRAND_NAME##, li adjuntem la seua targeta.",
            line2: "Per a activar la seua targeta, seguisca els passos que s'indiquen a continuació:",
            step1: "1. Iniciar sessió en l'aplicació",
            step2: '2. En el menú, seleccione "Configuració"\nrfidRequests.pdfText.step3,"3. Faça clic en l\'opció "Les meues targetes RFID',
            step3: '3. Feu clic a l\'opció "Les meves targetes RFID".',
            step4: '4. Faça clic en el botó "Afegir targeta RFID',
            step5: '"5. Introduïsca el número imprés en la targeta i polse el botó "Continuar""',
            step6: '6. La seua targeta ja està activada i pot utilitzar-se per a iniciar la seua pròxima sessió de càrrega',
            line3: 'Sabia que pot guanyar recompenses cada vegada que carrega? Rebrà un Volt per cada kWh consumit i, una vegada que haja acumulat suficients Volts, podrà canviar-los i utilitzar-los per a comprar sessions de càrrega en la xarxa.',
            line4: 'Gràcies per recarregar amb nosaltres.',
            line5: "L'equip de ##COMPANY_BRAND_NAME##",
            line6: 'Infraestructura de recàrrega de vehicles elèctrics al Regne Unit',
        },
    },
    RFIDCardFleets: {
        title: 'Targetes RFID: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Targetes RFID',
        placeholder: {
            name: 'Nom del conductor / Correu electrònic / Núm. vehicle',
            manufacturer: 'Fabricant',
            public_card_id: 'Identificació de la targeta pública',
            status: 'Seleccionar estat',
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Nom',
            manufacturer: 'Fabricant',
            part_id: 'Identificació de part',
            public_card_id: 'Identificació de la targeta pública',
            private_card_id: 'Identificació de la targeta privada',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activat',
            disabled: 'Desactivat',
            delete: 'Suprimir',
            remove: 'Eliminar Associació',
            reinstate: 'Restablir',
            activated: 'Activat',
            available: 'Disponible',
            duplicate: 'Duplicar',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            assing: 'Assignar targeta RFID',
            import: 'Importar fitxer',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acció',
            back: 'Tornar',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obtindre credencials',
            delete: 'Suprimir',
            remove: 'Eliminar Associació',
            reinstate: 'Restablir',
            exportAll: 'Exportar tot',
        },
        message: {
            enableConfirmMesage: 'Segur que vol activar-la?',
            disableConfirmMesage: 'Segur que vol desactivar-la?',
            deleteConfirmMesage: 'Segur que vol eliminar-la?',
            removeConfirmMesage: "Està segur que desitja eliminar l'associació de la targeta RFID a un compte",
            reinstateConfirmMessage: 'Està segur que desitja restablir la targeta RFID?',
        },
        insert: {
            header: 'Targeta RFID',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificació de part',
                public_card_id: 'Identificació de la targeta pública',
                private_card_id: 'Identificació de la targeta privada',
                mifare_uid: 'UID Mifare',
            },
            label: {
                manufacturer: 'Fabricant',
                part_id: 'Identificació de part',
                public_card_id: 'Identificació de la targeta pública',
                private_card_id: 'Identificació de la targeta privada',
                mifare_uid: 'UID Mifare',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                name: {
                    valid: 'Introduïsca un nom vàlid',
                },
                code: {
                    valid: 'Introduïsca un codi vàlid',
                },
                url: {
                    valid: 'La URL ha de ser una URL vàlida',
                },
            },
        },
        assignCards: {
            header: 'Assignar targeta RFID',
            label: {
                driver: 'Conductor/vehicle',
            },
            button: {
                yes: 'Asignar',
                no: 'Cancel·lar',
            },
            form: {
                driver: 'Conductor/vehicle',
                placeholder: {
                    driver: 'Seleccionar conductor/vehicle',
                },
            },
        },
        disableCards: {
            header: 'Desactivar',
            header2: 'Segur que vols desactivar-lo?',
            placeholder: {
                comment: 'Introduïsca un comentari',
            },
            label: {
                comment: 'Comentari',
            },
            button: {
                yes: 'Sí',
                no: 'No',
            },
        },
        importCards: {
            header: 'Importar targetes RFID',
            placeholder: {
                file: 'Seleccionar arxiu CSV',
            },
            label: {
                file: 'Arxiu CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancel·lar',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                file: {
                    fileType: "Es poden carregar arxius amb extensió'.csv'.",
                },
            },
        },
        importCardsDetails: {
            header: 'Detalls d’importació de targetes RFID',
            label: {
                unSuccessfullImport: 'Les targetes següents no es poden importar',
                successfullImport: 'Les targetes següents s’han importat correctament',
                failerReason: 'Motiu de la fallada',
                publicCardId: 'ID de targeta pública',
            },
            message: {
                defualtErrorMessage: 'Hi ha un problema a l’hora d’importar les targetes següents.',
            },
        },
    },
    myProfile: {
        title: 'El meu perfil: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'El meu perfil',
        subheader: {
            details: 'Dades personals',
            security: 'Seguretat',
            password: 'Contrasenya',
        },
        label: {
            firstName: 'Nom',
            lastName: 'Cognom',
            email: 'Correu electrònic',
            phoneNo: 'Telèfon',
            currentPassword: 'Contrasenya actual',
            newPassword: 'Nova contrasenya',
            confirmPassword: 'Torne a confirmar la seua contrasenya',
            mfaAuthentication: 'autenticació 2FA',
            authentication: 'Autenticació',
            securityCode: 'Codi de seguretat.',
            languagePreference: 'Preferència lingüística',
        },
        placeholder: {
            firstName: 'Nom',
            lastName: 'Cognom(s)',
            email: 'Correu electrònic',
            phoneNo: 'Telèfon',
            currentPassword: 'Contrasenya actual',
            newPassword: 'Nova contrasenya',
            confirmPassword: 'Torne a confirmar la seua contrasenya',
            securityCode: 'Codi de seguretat.',
            languagePreference: 'Preferència lingüística',
        },
        button: {
            save: 'Guardar',
            cancel: 'Cancel·lar',
            update: 'Actualització',
            ok: 'OK',
        },
        toast: {
            profileSuccess: 'Perfil actualitzat correctament',
            profileError: 'El perfil no està actualitzat. Per favor intente-ho més tard',
            passwordChange: "La contrasenya s'ha restablit correctament.",
            passwordErr: "La contrasenya no s'ha restablit correctament. Per favor intente-ho de nou més tard",
            passwordWrong: 'La contrasenya actual és incorrecta',
            securityStop: "La seguretat d'autenticació 2FA s'ha detingut.",
            error: 'Alguna cosa ha anat malament. Per favor intente-ho de nou més tard',
            securitySetupSuccess: "L'autenticació 2FA s'ha configurat correctament.",
            securitySetupError: "L'autenticació 2FA no s'ha configurat correctament, intente-ho de nou més tard.",
            securityCodeInvalid: 'Codi de seguretat invàlid.',
        },
        errors: {
            securityCode: {
                match: 'Per favor, introduïsca un codi vàlid',
                inValid: 'Per favor, introduïsca un codi de 6 dígits',
            },
            password: {
                confirmPasswordMatch: 'La nova contrasenya i la contrasenya de reconfirmació no coincidixen.',
            },
        },
    },
    apiCredentials: {
        title: 'Credencials API: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Credencials API',
        button: {
            generate: 'Generar fitxa',
            regenerate: 'Regenerar fitxa',
            yes: 'Sí',
            no: 'No',
        },
        note_no_permission:
            "No té drets per a accedir a la API. Pose's en contacte amb l'administrador de ##COMPANY_BRAND_NAME## per a obtindre accés.",
        note_generte_token:
            'Pot generar la fitxa fent clic en "Generate Token" & pot utilitzar esta fitxa per a accedir a la API.',
        note: 'Pot regenerar la fitxa fent clic en "Generate Token" & pot utilitzar esta fitxa per a accedir a la API.',
        label: {
            token: 'Fitxa',
            generate: 'Generar fitxa',
            regenerate: 'Regenerar fitxa',
        },
        message: {
            regenerateConfirmMesage:
                "Està segur que desitja regenerar la fitxa? <br/> Una vegada es regenere la fitxa, l'antiga no serà vàlida i no podrà accedir a la API des de l'antiga.",
            generateConfirmMesage: 'Està segur que desitja generar una fitxa?',
        },
    },
    cookiePolicy: {
        text: "Este lloc web utilitza cookies per a millorar l'experiència de l'usuari. En utilitzar el nostre lloc, vosté reconeix haver llegit i comprés la nostra",
        action: 'Política de cookies',
        iAccept: 'Accepto',
    },
    paymentconfig: {
        title: 'Pagaments - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Pagament',
        processingNote: 'Espere mentres es processa la seua transacció',
        purchaseOrderNote: 'Té un cicle de facturació ##PAYMENT_SCHEDULE##. La seua pròxima data de facturació serà: ',
        description: 'Pagaments a ##COMPANY_BRAND_NAME##',
        note: "El treball en segon pla s'executarà cada setmana per a liquidar les factures pendents per la recàrrega de vehicles elèctrics realitzada pels conductors/vehicles ",
        addReplaceCardNote:
            "Tinga en compte que en afegir una targeta de pagament es carregarà en el seu compte ##CURRENCY_SYMBOL_WITH_VALUE## que s'abonarà en el saldo del seu moneder ##COMPANY_BRAND_NAME##.",
        label: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crèdit disponible',
            unbilledAmount: 'Import no facturat',
            cardTitle: 'Nom en la tarjeta',
            cardNumber: 'Numere de targeta',
            expiry: 'Caducitat',
            note: 'Nota: ',
            CSC: 'CSC',
            cardSecurityCode: '(Codi de seguretat de la targeta)',
            charityDonation: 'Donació benèfica',
            roundUp: 'Arredonir',
            topUp: 'Recarregar',
            expires: 'Caduca',
            charity: 'Caritat',
        },
        placeholder: {
            cardTitle: 'Nom en la tarjeta',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00,00',
        },
        button: {
            save: 'Guardar',
            edit: 'Editar',
            replace: 'Substituir',
            back: 'Tornar',
            payNow: 'Pagar ara',
        },
        errors: {
            CSC: {
                min: 'Introduïsca un codi de 3 dígits.',
            },
            topupAmount: {
                min: 'El Import caritatiu ha de ser major o igual a 0,1',
            },
            cardNumber: {
                inValid: 'Número de targeta invàlid.',
            },
            commonError: "S'ha produït un error en processar la seua sol·licitud, per favor intente-ho de nou més tard",
            transactionFailed: 'La seua transacció ha fallat, per favor intente-ho de nou',
        },
        message: {
            cardSaved: "Les dades de la targeta s'han guardat correctament",
        },
    },
    refundRequest: {
        title: 'Aprovacions de retirada - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Aprovacions de retirada',
        accountInfoNote: 'Informació del compte introduït per a realitzar la retirada:',
        completeConfirmNote:
            'Emplene esta sol·licitud de retirada només si ha abonat en el compte bancari del conductor el valor indicat. Desitja continuar?',
        bulkCompleteConfirmNote:
            'Emplene ests sol·licituds de retirada només si ha abonat en el compte bancari del conductor el valor indicat. Desitja continuar?',
        declineConfirmNote:
            "Assegure's que ha introduït un motiu adequat per a rebutjar la sol·licitud, ja que esta informació es transmet al client.  Desitja continuar?",
        bulkDeclineConfirmNote:
            "Assegure's que ha introduït un motiu adequat per a rebutjar las sol·licituds, ja que esta informació es transmet al client.  Desitja continuar?",
        label: {
            name: 'Nom',
            reviewRequest: 'Sol·licitud de revisió',
            driverName: 'Nom del conductor',
            driverEmail: 'Correu electrònic del conductor',
            requestedDate: 'Data sol·licitada',
            action: 'Acció',
            amount: 'Import',
            refundRequested: 'Retirada sol·licitada',
            status: 'Estat',
            accountNumber: 'Número de compte',
            sortCode: "Codi d'ordenació",
            enterComments: 'Introduïsca comentaris',
            pending: 'Pendent',
            closed: 'Tancat',
            complete: 'Completar',
            decline: 'Rebutjar',
            review_by: 'Revisat per',
            review_date: "Revisat el/l'",
            approvalRequest: 'Sol·licitud aprovada',
            processRefundRequest: 'Sol·licitud de procés de retirada',
            completeRefundRequest: 'Retirada sol·licitada-completada',
            bulkCompleteRefundRequest: 'Retiradas sol·licitades-completades',
            declineRefundRequest: 'Rebutjar la retirada sol·licitada',
            bulkdeclineRefundRequest: 'Rebutjar les retirades sol·licitades',
            export: 'Exportar dades',
            bulk: 'En bloc',
        },
        button: {
            decline: 'Rebutjar',
            approve: 'Aprovar',
            reset: 'Restablir',
            search: 'Buscar',
            complete: 'Completar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
        },
        placeholder: {
            selectStatus: 'Seleccionar estat',
            enterComments: 'Introduïsca comentaris',
            name: 'Nom/Correu electrònic',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Per favor, emplene o rebutge esta sol·licitud.',
            },
            selectWithdrawalApprovals: 'Seleccione les sol·licituds de retirada',
        },
    },
    termsAndConditionListing: {
        title: 'Condicions generals - ##COMPANY_BRAND_NAME##: Recàrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Condicions generals',
        noteDetails: "*Han d'acceptar-se obligatòriament per a poder utilitzar/registrar un compte.",
        label: {
            iAggreeToTermsCondition: 'Acepte',
            note: 'Nota: ',
            termsAndConditions: 'Condicions generals',
            reviewUpdatedCondition:
                'Per favor, revise i accepte els termes actualitzats & condicions que figuren a continuació.',
            name: 'Nom',
        },
        button: {
            accept: 'Acceptar',
            next: 'Següent',
            cancel: 'Cancel·lar',
        },
        errors: {
            acceptTermCondition: 'Per favor, accepte * les Condicions Generals per a continuar',
        },
    },
    adminDashboard: {
        title: 'Inici: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Quadre de comandaments',
        formtitle: 'Validació de formularis',
        label: {
            filter: 'Filtre',
            reportTags: "Etiquetes de l'informe",
            driverGroup: 'Grups de conductors',
            selectDriverGroup: 'Seleccionar Grups de conductors',
            selectTags: 'Seleccionar Etiquetes',
            dateRange: 'Interval de dates',
            month: 'Mes',
            year: 'Any',
            day: 'Dia',
            week: 'Setmana',
            userSessionTitle: 'Sessions de conductors',
            userSessions: 'Sessions de conductors',
            totalIncomeTitle: "Suma d'ingressos",
            income: 'Ingresos',
            transactionTitle: 'Transacció mitjana',
            transaction: 'Transacció',
            energy: 'Energia',
            energyTitle: "Suma d'energia (kWh)",
            failedPaymentTitle: 'Nombre de pagaments fallits',
            failedPayment: 'Pagaments fallits',
            driverCountTitle: 'Compte del conductor',
            driver: 'Conductor',
            accumulatedVolts: 'Volts acumulats',
            claimedVolts: 'Volts reclamats ',
            outStandingFailPayment: 'Pagament pendent fallit',
            outStandingFailedPaymentTitle: 'Pagaments pendents fallits',
            voltsLiability: 'Responsabilitat Volts',
            voltsAccumulatedTitle: 'Volts acumulats',
            volts: 'Volts',
            voltsClaimedTitle: 'Volts declarats',
            lapsedVolts: 'Volts caducats',
            totalNoOfDriverAccount: 'Nombre total de comptes de conductors',
            enabled: 'Activat',
            disabled: 'Desactivat',
            badDebtor: 'Deutor morós',
            cancelled: 'Cancel·lat',
            deleted: 'Suprimit',
            fake_account: 'Compte fals',
            numberOfReferees: 'Nombre de persones designades',
            numberOfReferrers: 'Nombre de remissors',
            referralPayment: 'Pagaments per remissió (remitent + persona designada)',
            referrer: 'Remissor',
            referee: 'Persona designada',
            moneySpent: 'Diners gastats només per les persones designades',
            referralBonus: 'bonificació per recomanació',
            referralPromotion: 'Promoció per recomanació',
            overnightAutomated: 'Automatització nocturna',
            customerManual: 'Manual del client',
            pending: 'Pendent',
            patnerPromoClicksCount: 'Recompte de clics de les promocions de socis ',
            clicksCount: 'Recompte de clics',
            clicksCountMessage:
                'Seleccione una o diverses opcions per a mostrar el recompte de clics de la promoció de socis',
            individualDrivers: 'Comptes dels conductors activats',
            organisationDrivers: 'Comptes dels conductors activats',
            individualAndOrgDriverCount: 'Activar Comptes: Conductors versus Organitzacions',
            alerts: 'Alertes',
            alertsCountTitle: "Recompte d'alertes",
            premiumSubscriptions: 'Subscripcions Premium',
            activeSubscriptions: 'Total de subscripcions Premium actives',
            newSubscriptions: 'Noves Subscripcions',
            cancelledSubscriptions: 'Subscripcions cancel·lades',
            subscriptions: '(Subscripcions)',
        },
        placeholder: {
            patnerPromotions: 'Seleccione una o diverses promocions associades per a mostrar les dades',
        },
        button: {
            apply: 'Sol·licitar',
            clear: 'Esborrar',
            syncData: 'Sincronitzar dades',
        },
    },
    footer: {
        version: 'Versió',
        copyRightText: 'Tots els drets reservats',
    },
    cardReader: {
        title: 'Lectors de targetes: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Lectors de targetes',
        manageCardReader: 'Gestionar lector de targetes',
        importHeader: 'Importar lectors de targetes',
        button: {
            import: 'Importar',
            add: 'Afegir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            edit: 'Editar',
            action: 'Acció',
            delete: 'Suprimir',
            search: 'Buscar',
            reset: 'Restablir',
            disable: 'Desactivar',
            duplicate: 'Duplicar',
            active: 'Actiu',
            chargeStation: 'Estacions de recàrrega',
            yes: 'Sí',
            no: 'No',
            claimCardReader: 'Reclameu lectors de targetes no assignats',
            claim: 'Reclamació',
        },
        label: {
            description: 'Descripció',
            latitude: 'Latitud',
            longitude: 'Longitud',
            serialNumber: 'Número de sèrie',
            endPoint: 'Punt final',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Suprimir',
            csvFile: 'Arxiu CSV',
            clickHere: 'Polse ací',
            downloadTemplate: 'per a descarregar plantilla',
            evse_id: 'ID EVSE',
            error: 'Error',
            errorDetail: "Detalls de l'error",
            failureReason: 'Motiu del fracàs',
            id: 'ID del lector de targetes',
        },
        placeholder: {
            description: 'Descripció',
            latitude: 'Latitud',
            longitude: 'Longitud',
            serialNumber: 'Número de sèrie',
            endPoint: 'Anul·lar punt final',
            selectStatus: 'Seleccionar estat',
        },
        errors: {
            latitude: {
                min: "La latitud ha d'estar compresa entre -90,0 i 90,0",
                max: "La latitud ha d'estar compresa entre -90,0 i 90,0",
                number: 'La latitud ha de ser un número',
            },
            longitude: {
                min: "La longitud ha d'estar compresa entre -180,0 i 180,0",
                max: "La longitud ha d'estar compresa entre -180,0 i 180,0",
                number: 'La longitud ha de ser un número',
            },
            serial_number: {
                valid: 'Introduïsca un número de série vàlid',
            },
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            duplicateConfirmMesage: 'Estàs segur que vol duplicar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
            activeConfirmMesage: 'Segur que vol activar-lo?',
        },
        assign: {
            header: 'Estacions de recàrrega',
            headerModal: 'Estació de recàrrega',
            placeholder: {
                name: 'Introduïsca el nom',
                address: 'Adreça',
                tags: 'Seleccionar Etiquetes',
            },
            label: {
                add: 'Afegir',
                address: 'Adreça',
                city: 'Ciutat',
                name: 'Nom',
                type: 'Tipus',
                physical_reference: 'Referència física',
                postcode: 'Codi postal',
                action: 'Acció',
                delete: 'Suprimir',
            },
            button: {
                delete: 'Suprimir',
            },
            message: {
                deleteConfirmMesage: 'Segur que vols eliminar-la?',
            },
        },
    },
    cardScheme: {
        title: 'Esquemes de targeta: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Esquemes de targeta',
        manageCardScheme: 'Gestionar Esquemes de targeta',
        label: {
            TransIdSeed: 'ID de Transaccions Seed',
            keybEncrKey: 'ClauB Clau de xifratge',
            transIdEncrKey: 'Clau de xifratge de la identificació de Transaccions',
            emspCode: 'Codi EMSP',
            endPoint: 'Punt final',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Suprimir',
            enabled: 'Activat',
            disabled: 'Desactivat',
        },
        button: {
            import: 'Importar',
            add: 'Afegir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            edit: 'Editar',
            action: 'Acció',
            delete: 'Suprimir',
            search: 'Buscar',
            reset: 'Restablir',
            disable: 'Desactivar',
            enable: 'Activar',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-ho?',
            disableConfirmMesage: 'Segur que vol desactivar-ho?',
            enableConfirmMesage: 'Segur que vol activar-ho?',
        },
        placeholder: {
            emspCode: 'Codi EMSP',
            keybEncrKey: 'ClauB Clau de xifratge',
            transIdEncrKey: 'Clau de xifratge de la identificació de Transacció',
            TransIdSeed: 'ID de Transaccioó Seed',
        },
        errors: {
            emsp_code: {
                valid: 'Introduïsca un codi vàlid EMSP',
            },
            transaction_id_seed: {
                valid: 'Introduïsca una identificació de transacció seed vàlida',
                min: 'La identificació de la transacció seed no pot ser menys que 0',
                max: 'Límit màxim aconseguit per a la identificació de la transacció seed',
            },
        },
    },
    fleetProfile: {
        orgProfile: "Perfil de l'organització",
        message: {
            success: "Perfil de l'organització actualitzat correctament",
        },
    },
    dataAggregator: {
        title: 'Agregadors de dades: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Agregadores de datos',
        button: {
            add: 'Afegir',
            search: 'Buscar',
            reset: 'Restablir',
            enable: 'Activar',
            disable: 'Desactivar',
            edit: 'Editar',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            syncDataAggregatorAPIKeys: "Sincronitza les claus API amb els plans d'ús",
        },
        placeholder: {
            name: 'Nom',
            status: 'Seleccionar estat',
        },
        label: {
            enabled: 'Activat',
            disabled: 'Desactivat',
            name: 'Nom',
            party_id: 'Identificació de part',
            country_code: 'Codi del país',
            version_url: 'Versió URL',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
        },
        message: {
            enableConfirmMesage: 'Segur que vol activar-ho?',
            disableConfirmMesage: 'Segur que vol desactivar-ho?',
        },
        insert: {
            header: 'Gestionar agregadors de dades',
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                name: {
                    valid: "Introduïsca un nom vàlid d'agregador de dades",
                },
                party_id: {
                    valid: 'Introduïsca una identificació de Part vàlida',
                },
                country_code: {
                    valid: 'Introduïsca un codi vàlid de pais',
                },
                version_url: {
                    url: 'La URL de la versió ha de ser una URL vàlida',
                },
                token: {
                    valid: 'Introduïsca una fitxa vàlida',
                },
            },
            placeholder: {
                name: 'Nom',
                party_id: 'Identificació de part',
                country_code: 'Codi del país',
                version_url: "Versió URL de l'agregador de dades",
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                emsp: 'EMSP',
                access_group: "Grup d'accès",
                usagePlan: "Pla d'ús",
            },
            label: {
                name: 'Nom',
                party_id: 'Identificació de part',
                country_code: 'Codi del país',
                version_url: 'Versió URL',
                emsp: 'EMSP',
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                allow_locations_to_be_extracted: "Permetre que només s'extraguen ubicacions del EMPS",
                allow_receive_location_update:
                    "Permetre que es reben actualitzacions d'ubicació PUT (començament inicial) i PATCH (actualització d'estat)",
                access_group: "Grup d'accès",
                allow_tariff_extraction: 'Inclòs Tarifa',
                usagePlan: "Pla d'ús",
            },
        },
    },
    accessGroups: {
        title: "Grup d'accès: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
        header: "Grups d'accès",
        manageAccessGroup: "Gestionar Grup d'accès",
        label: {
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Suprimir',
            enabled: 'Activat',
            disabled: 'Desactivat',
            name: 'Nom',
            description: 'Descripció',
            access_control_type: "Tipus de control d'accés",
            allow_public_access: "Permetre l'accés públic",
            managed_by_organisation: "Gestionat per l'Organització",
            override_tariff: 'Anul·lar tarifa',
            yes: 'Sí',
            no: 'No',
            access_code: "Codi d'accés",
            deleted: '(Suprimit)',
        },
        button: {
            enable: 'Activar',
            disable: 'Desactivar',
            action: 'Acció',
            edit: 'Editar',
            delete: 'Suprimir',
            enabled: 'Activat',
            disabled: 'Desactivat',
            add: 'Afegir',
            search: 'Buscar',
            reset: 'Restablir',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            deleted: '(Suprimit)',
            chargeStation: 'Ubicacions de la recàrrega',
            yes: 'Sí',
            no: 'No',
            drivers: 'Conductors',
        },
        placeholder: {
            name: 'Nom',
            selectStatus: 'Seleccionar estat',
            allow_public_access: "Permetre l'accés públic",
            description: 'Descripció',
            access_control_type: "Tipus de control d'accés",
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            disableConfirmMesage: 'Segur que vol desactivar-lo?',
            enableConfirmMesage: 'Segur que vol activar-lo?',
        },
        assign: {
            header: 'Ubicacions de la recàrrega',
            headerModal: 'Ubicacions de la recàrrega',
            placeholder: {
                name: 'Introduïsca el nom',
                address: 'Adreça',
                tags: 'Seleccionar Etiquetes',
                postal_code: 'Codi postal',
                power_type: "Seleccione el tipus d'alimentació",
            },
            label: {
                add: 'Afegir',
                address: 'Adreça',
                city: 'Ciutat',
                name: 'Nom',
                type: 'Tipus',
                physical_reference: 'Referència física',
                postcode: 'Codi postal',
                action: 'Acció',
                delete: 'Suprimir',
            },
            button: {
                delete: 'Suprimir',
            },
            message: {
                deleteConfirmMesage: 'Segur que vol eliminar-lo?',
            },
        },
        driverAssign: {
            header: 'Conductors',
            headerModal: 'Conductors',
            placeholder: {
                email: 'Correu electrònic',
                status: 'Estat',
            },
        },
        errors: {
            name: {
                valid: 'Introduïsca un nom vàlid',
            },
        },
    },
    accessGroupRequests: {
        title: "Sol·licituds de Grup d'Accés: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
        header: "Sol·licituds de Grup d'Accés",
        columns: {
            name: 'Nom',
            email: 'Correu electrònic',
            federated_account_type: 'Tipus de compte federat',
            requested_access_group: "Grup d'accés sol·licitat",
            requested_date: 'Data sol·licitada',
            driver_status: 'Estat del conductor',
            request_status: 'Estat de la sol·licitud',
            action: 'Acció',
        },
        button: {
            action: 'Acció',
            search: 'Buscar',
            reset: 'Restablir',
            save: 'Guardar',
            cancel: 'Cancel·lar',
        },
        label: {
            review_request: 'Sol·licitud de revisió',
            requested_access_group: "Grup d'accés sol·licitat:",
            approve: 'Aprovar',
            decline: 'Rebutjar',
            enterComments: 'Comentaris',
        },
        placeholder: {
            nameEmail: 'Nom / Correu electrònic',
            startDate: "Data d'inici",
            endDate: 'Data final',
            status: 'Seleccionar estat',
            enterComments: 'Introduïsca els seus comentaris',
        },
        errors: {
            approveReject: 'Per favor, aprove o rebutge esta sol·licitud.',
        },
    },
    payByWeb: {
        title: 'Pagament per Web: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Pagament per Web',
        columns: {
            evse_id: 'ID EVSE',
            status: 'Estat',
            physical_reference: 'Referència física',
            location_name: 'Nom de la ubicació',
            location_address: 'Adreça',
            location_city: 'Ciutat',
            location_postal_code: 'Codi postal',
            pay_by_web_active: 'Pagament per Web',
            action: 'Acció',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            enablePayByWeb: 'Activar pagament per Web',
            disabledPayByWeb: 'Deasactivar pagament per Web',
            submit: 'Enviar',
            cancel: 'Cancel·lar',
        },
        label: {
            enabled: 'Activar',
            disabled: 'Desactivar',
            manageUniqueCode: 'Gestionar codi únic',
            uniqueCode: 'Codi únic',
        },
        message: {
            enableConfirmMesage: 'Està segur que vol activar el pagament per web per a les estacions seleccionades?',
            disableConfirmMesage:
                'Està segur que vol desactivar el pagament per web per a les estacions seleccionades?',
        },
        placeholder: {
            evse_id: 'ID EVSE',
            status: 'Seleccionar estat',
            physical_reference: 'Referència física',
            location_name: 'Nom de la ubicació',
            location_address: 'Adreça',
        },
        errors: {
            unique_code: {
                valid: 'Introduïsca un codi vàlid únic',
            },
        },
    },
    driverDebt: {
        title: 'Deute del conductor: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Deute del conductor',
        button: {
            download: 'Descarregar',
            strikeOneLetter: 'Ratllar una carta',
            strikeTwoLetter: 'Ratllar dos cartes',
            generateStrikeOneLetters: 'Generar un titllat de cartes',
            generateStrikeTwoLetters: 'Generar dos titllats de cartes',
            runHistory: "Generar titllat de cartes - Historial d'execució",
            pastLetters: 'Cartes anteriors',
            regenerateLetters: 'Regenerar cartes',
            refreshPastLetters: 'Actualitzar cartes anteriors',
        },
        label: {
            pastLetters: 'Cartes anteriors',
            inProgress: '(en curs)',
            noDataFound: "No s'han trobat dades.",
            dynamicFields: 'Camps dinàmics',
            clickToCopy: "(faça clic per a copiar l'anotació)",
            driverName: 'Nom del conductor',
            driverDebt: 'Deute del conductor',
            debtAge: 'Antiguitat del deute',
            driverEmail: 'Correu electrònic del conductor',
            driverAddress: 'Adreça de conductors',
            date: 'Data',
            clickToCopyTooltip: 'Faça clic per a copiar',
            regenerate: 'Regenerar',
            regenerateLetters: 'Regenerar cartes',
            letterTemplate: 'Model de carta',
            cancel: 'Cancel·lar',
            reportGenerationInProgress: "(Generació d'informes en curs)",
            copyDriverIds: 'Faça clic per a copiar els identificadors dels conductors',
        },
        columns: {
            run: 'Executar Núm.',
            driverIDs: "Documents d'identificació dels conductors admissibles en este punt de l'execució",
            runTimestamp: 'Marca horaria de ejecución',
            strikeType: 'Tipus de exercici',
            initiatedByUser: "Usuari que va iniciar l'execució",
            regenerate: 'Regenerar',
            action: 'Acció',
            relatedRun: "Núm. d'execució relacionat",
            date: 'Data',
            file: 'Arxiu',
            templateUsed: 'Model utilitzat',
            generatedBy: 'Generar CDR per',
        },
        placeholder: {
            strikeOneLetter: 'Seleccionar un titllat de cartes',
            strikeTwoLetter: 'Seleccionar dos titllats de cartes',
        },
    },
    fleetAccessGroups: {
        title: "Sol·licituds de Grup d'Accés: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
    },
    emailLogs: {
        title: 'Registres de correu electrónic: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Registres de correu electrònic',
        columns: {
            recipient: 'Destinatari',
            subject: 'Assumpte',
            deliveryStatus: 'Estat del lliurament',
            errorMessage: "Missatge d'error",
            createdDate: 'Data de creació',
        },
        label: {
            viewError: 'Veure error',
        },
        placeholder: {
            recipient: 'Destinatari',
            subject: 'Assumpte',
            deliveryStatus: 'Estat del lliurament',
            errorMessage: "Missatge d'error",
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
    },
    alerts: {
        title: "Registres d'errors OCPI: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service",
        header: "Registres d'errors OCPI",
        columns: {
            api: 'url',
            api_call_type: 'Tipus de telefonada API',
            api_request_type: 'Tipus de sol·licitud',
            response_code: 'Codi de resposta',
            error_message: "Missatge d'error",
            alert_type: "Tipus d'alerta",
            created_date: 'Data de creació',
            request_body: 'Cos de la sol·licitud',
            response_body: 'Cos de resposta',
        },
        placeholder: {
            api: 'url',
            alert_type: "Tipus d'alerta",
            startDate: "Data d'inici",
            endDate: 'Data final',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
        },
        label: {
            viewDetails: 'Veure detalls',
            errorLogDetails: "Detalls de registres d'errors OCPI",
        },
    },
    SubscriptionSetting: {
        title: 'Subscripcions Premium: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Subscripcions Premium',
        manageSubscription: 'Gestionar Subscripcions Premium',
        label: {
            subscription_type: 'Tipus de subscripció',
            subscription_amount: 'Importe de subscripció',
            free_subscription_duration: 'Duració de la subscripció gratuïta',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activar',
            disabled: 'Desactivar',
            maximum_routing_call: "Nombre màxim de crides d'encaminament (per mes)",
            additional_volts_per_kwh: 'Volt(s) addicional(s) Recompensa / kWh',
            name: 'Nom',
            description: 'Descripció',
            subscriptionImage: 'Subscripció Premium Imatge',
            exportSubscribersList: 'Exportar llista de subscriptors',
            downloadSubscribersList: 'Descarregar llista de subscriptors',
        },
        placeholder: {
            subscription_amount: 'Import de subscripció',
            free_subscription_duration: 'Duració de la subscripció gratuïta (Dies)',
            maximum_routing_call: "Nombre màxim de crides d'encaminament",
            name: 'Nom',
            status: 'Seleccionar estat',
            subscriptionType: 'Seleccione el tipus de subscripció',
            subscriptionImage: 'Selectinar Imatge subscripció Premium',
        },
        button: {
            action: 'Acció',
            disable: 'Desactivar',
            enable: 'Activar',
            edit: 'Editar',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            enableDisable: 'Activar / Desactivar subscripció',
            add: 'Afegir',
            search: 'Buscar',
            reset: 'Restablir',
        },
        errors: {
            amount: {
                moreThan: "L'import ha de ser superior a 1",
                lessThan: "L'import ha de ser inferior a 100",
                number: "L'import ha de ser un número",
            },
            duration: {
                moreThan: 'La duració ha de ser superior a 1',
                lessThan: 'La duració ha de ser inferior a 180',
            },
            maxRoutingCall: {
                moreThan: "El valor màxim de crides d'encaminament ha de ser superior a 1",
                lessThan: "El valor màxim de crides d'encaminament ha de ser inferior a 1000",
            },
            additionalVolts: {
                lessThan: 'El valor ha de ser inferior o igual a 5',
                number: 'El valor ha de ser un número',
            },
        },
        message: {
            enableFromConfig:
                'Per a habilitar una subscripció Premium, primer configure "Habilitar subscripció Premium" a "Verdader" en Ajustos > Configuracions',
            disableConfirmMessage:
                'Avís: En desactivar la Subscripció Premium, es cancel·laran totes les renovacions automàtiques associades al compte del Conductor. Segur que vols desactivar?',
            enableConfirmMessage: 'Segur que vols activar?',
        },
    },
    advertisingDevices: {
        title: 'Dispositius publicitaris: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Dispositius publicitaris',
        label: {
            enabled: 'Activat',
            disabled: 'Desactivat',
            device_name: 'Nom',
            device_id: 'Identificació del dispositiu',
            postal_code: 'Codi postal',
            charge_station: 'Estació de recàrrega',
            screen_size: 'Grandària de la pantalla',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Suprimir',
            operational: 'Operatiu',
        },
        button: {
            action: 'Acció',
            edit: 'Editar',
            delete: 'Suprimir',
            enabled: 'Activar',
            disabled: 'Desactivar',
            add: 'Afegir',
            reset: 'Restablir',
            search: 'Buscar',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            assignVideos: 'Asignar vídeos',
            yes: 'Sí',
            no: 'No',
            regenerateS3File: 'Regenerar arxiu S3',
            mediaTerminalLogs: 'Registres de terminals multimèdia',
        },
        placeholder: {
            device_name: 'Nom del dispositiu',
            postal_code: 'Codi postal',
            charge_station: 'Estació de recàrrega',
            selectStatus: 'Seleccionar estat',
            screen_size: 'Grandària de la pantalla',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-ho?',
            enableConfirmMesage: 'Segur que vol activar-ho?',
            disableConfirmMesage: 'Segur que vol desactivar-ho?',
        },
        insert: {
            header: 'Gestionar dispositiu publicitari',
            placeholder: {
                device_name: 'Nom del dispositiu',
                device_id: 'Identificació del dispositiu',
                charge_station: 'Estació de recàrrega',
                screen_size: 'Grandària de la pantalla',
            },
            label: {
                device_name: 'Nom del dispositiu',
                device_id: 'Identificació del dispositiu',
                charge_station: 'Estació de recàrrega',
                screen_size: 'Grandària de la pantalla',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, per favor intente-ho de nou.',
                name: {
                    valid: 'Introduïsca un nom vàlid',
                },
                device_id: {
                    valid: 'Introduïsca una identificació de dispositiu',
                    min: 'El dispositiu ha de tindre almenys 6 caràcters',
                },
            },
        },
        assignVideos: {
            header: 'Vídeos',
            headerModal: 'Vídeos',
            label: {
                action: 'Acció',
                delete: 'Suprimir',
            },
            placeholder: {
                file_name: "Nom de l'arxiu",
                description: 'Descripció',
            },
            message: {
                deleteConfirmMesage: 'Segur que vol eliminar-ho?',
            },
        },
    },
    advertisingVideos: {
        title: 'Vídeos publicitaris: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Vídeos publicitaris',
        label: {
            file_name: "Nom de l'arxiu",
            description: 'Descripció',
            operational_start_date: "Data d'inici de les operacions",
            operational_end_date: 'Data de finalització de les operacions',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Suprimir',
            reviewVideo: 'Vídeo de revisió',
            approve: 'Aprovar',
            reject: 'Rebutjar',
            videoUpload: 'Vídeo',
            comments: 'Comentaris',
        },
        button: {
            action: 'Acció',
            edit: 'Editar',
            delete: 'Suprimir',
            enabled: 'Activar',
            disabled: 'Desactivar',
            add: 'Afegir',
            reset: 'Restablir',
            search: 'Buscar',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            reviewVideo: 'Vídeo de revisió',
            downloadVideo: 'Descarregar vídeo',
            assignDevice: 'Assignar dispositius',
        },
        placeholder: {
            file_name: "Nom de l'arxiu",
            description: 'Descripció',
            start_date: "Data d'inici de les operacions",
            end_date: 'Data de finalització de les operacions',
            selectStatus: 'Seleccionar estat',
            videoUpload: 'Vídeo',
            enterComments: 'Introduïsca els seus comentaris',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-ho?',
        },
        insert: {
            header: 'Gestionar el vídeo publicitari',
            placeholder: {
                description: 'Descripció',
                operational_start_date: "Data d'inici de les operacions",
                operational_end_date: 'Data de finalització de les operacions',
            },
            label: {
                description: 'Descripció',
                operational_start_date: "Data d'inici de les operacions",
                operational_end_date: 'Data de finalització de les operacions',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Per favor, aprove o rebutge esta sol·licitud.',
                },
            },
            name: {
                valid: 'Introduïsca un nom vàlid',
            },
            file_name: {
                fileType: "Es poden penjar arxius amb extensió '.mp4', '.flv', '.wmv', '.mpeg', '.avi', '.3gp'",
                uploadError: "Error en penjar l'arxiu de vídeo",
                required: 'Es requerix arxiu de vídeo',
                fileNameLength: "Es permet un màxim de 15 caràcters per al nom de l'arxiu",
            },
            file_size: "El límit màxim de càrrega d'arxius és",
        },
        assignDevices: {
            header: 'Dispositius',
            headerModal: 'Dispositius',
            label: {
                action: 'Acció',
                delete: 'Suprimir',
            },
            placeholder: {
                device_name: 'Nom del dispositiu',
                device_id: 'Identificació del dispositiu',
                status: 'Estat',
            },
            message: {
                deleteConfirmMesage: 'Segur que vol eliminar-ho?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Credencials de publicitat ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Credencials de publicitat',
        manageCredentials: 'Gestionar credencials de publicitat',
        label: {
            bucket_name: 'Nom del balde',
            region_name: 'Nom de la regió',
            download_access_key: 'Descarregar clau accès',
            download_secret_key: 'Descarregar clau secreta',
            upload_access_key: "Carregar clau d'accés",
            upload_secret_key: 'Carregar clau secreta',
            download_info_object_name: "Descarregar informació del nom de l'objecte",
            upload_path: 'Carregar ruta',
            dialog_password: 'Diàleg contrasenya',
            expect_bucket_name: 'Preveure nom del balde',
            expect_region_name: 'Preveure nom de la regió',
            expect_download_access_key: 'Preveure descarregar clau accès',
            expect_download_secret_key: 'Preveure descarregar clau secreta',
            version_code: 'Codi de la versió',
            download_url: 'Descarregar URL',
            prompt: 'Pregunte a',
            remarks: 'Observacions',
            modified_by: 'Modificat per',
            modified_date: 'Data de modificació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Activar',
            disabled: 'Desactivar',
        },
        button: {
            action: 'Acció',
            disable: 'Desactivar',
            enable: 'Activar',
            edit: 'Editar',
            back: 'Tornar',
            save: 'Guardar',
            cancel: 'Cancel·lar',
        },
    },
    organisationInvoices: {
        title: 'Organització de les Factures: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Organització de les Factures',
        label: {
            name: 'Organització',
            invoice_id: 'Identificació de la factura',
            invoice_value: 'Valor de la factura',
            invoice_date: 'Data de la factura',
            action: 'Acció',
            undo: 'Desfer',
            undoPayment: 'Desfer el Pagament',
            disputed: 'Disputat',
            adjustAmount: 'Ajustar el valor de la factura ',
            paid_value: 'Valor pagat',
            outstanding: 'Destacat',
            status: 'Estat',
            comments: 'Comentaris',
            original_value: 'Valor original',
        },
        placeholder: {
            name: 'Nom',
            start_date: "Data d'inici",
            end_date: 'Data final',
            status: 'Estat',
            organisation: 'Seleccionar Organització',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablir',
            action: 'Acció',
            pay: 'Pagar',
            partPay: 'Pagament parcial',
            undo: 'Desfer',
            disputed: 'Disputat',
            adjustValue: 'Ajustar el valor de la factura',
        },
        errors: {
            amount: {
                moreThan: "L'import ha de ser major que 0",
                maxValue: "Valor màxim aconseguit per a l'import",
                notZero: "L'import ha de ser major/menor que 0",
                minValue: "Valor mínim aconseguit per a l'import",
                number: "L'import ha de ser un número",
            },
            organisation: {
                required: "Per favor, seleccione l'Organització",
            },
        },
        message: {
            undoConfirmMessage:
                'Està segur que desitja eliminar el valor pagat i establir l\'estat en "Pendent" per a esta factura?',
            disputedConfirmMessage: 'Està segur que desitja establir l\'estat en "Impugnada" per a esta factura?',
        },
        payModal: {
            header: 'Pagar',
            partPayHeader: 'Pagament parcial',
            label: {
                amount: 'Import',
                date_paid: 'Data de pagament',
                comments: 'Comentaris',
            },
            placeholder: {
                amount: " Introduïsca l'import",
                date_paid: 'Introduïsca data de pagament',
                comments: 'Introduïsca comentaris',
            },
            button: {
                accept: 'Acceptar',
                send_for_approval: 'Enviar per a aprovació',
                cancel: 'Cancel·lar',
                submit: 'Enviar',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Registres de terminals multimèdia: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Registres de terminals multimèdia',
        label: {
            file_name: "Nom de l'arxiu",
            date_played: 'Data de reproducció',
            play_time: 'Temps de reproducció',
            start_time: "Data d'inici",
        },
        placeholder: {
            fileName: "Nom de l'arxiu",
            startDate: "Data d'inici",
            endDate: 'Data de finalització ',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Historial de límits de despesa: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Historial de límits de despesa',
        label: {
            enabled: 'Activat',
            disabled: 'Desactivat',
            name: 'Nom del conductor',
            email: 'Correu electrònic del conductor',
            type: 'Tipus de llindar',
            spend_limit_exceed_date: 'Data de superació del límit de despeses',
            status: 'Estat del conductor',
            action: 'Acció',
            export: 'Exportar',
            onStop: 'En parada',
            cancelOnStop: 'Cancel·lar en parada',
        },
        button: {
            disable: 'Desactivar',
            enable: 'Activar',
            search: 'Buscar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            back: 'Tornar',
        },
        placeholder: {
            name: 'Nom del conductor',
            email: 'Correu electrònic del conductor',
            status: 'Seleccionar estat del conductor',
            dateFrom: 'Data de superació del límit des de',
            dateTo: 'Data de superació del límit fins a',
            type: 'Seleccionar tipus de llindar',
        },
        message: {
            noDataToExport: 'No hi ha dades que exportar.',
            cancelOnStopConfirmation: "Està segur que desitja cancel·lar la parada d'este conductor?",
        },
    },
    driverDebtorLetters: {
        title: 'Cartes de conductor deutor: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Cartes de conductor deutor',
        manageDriverDebtorLetter: 'Gestionar cartes de conductor deutor',
        label: {
            reportType: "Tipus d'informe",
            defaultLetter: 'Model per defecte de carta de deutor morós',
            content: 'Contingut',
            enabled: 'Activat',
            disabled: 'Desactivat',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Suprimir',
            dynamicFields: 'Camps dinàmics',
            copyNotation: "(Faça clic per a copiar l'anotació)",
            clickToCopy: 'Faça clic per a copiar',
            driverName: ' nom del conductor â€¢',
            driverDebt: 'deute del conductor â€¢',
            debtAge: 'antiguitat del deute â€¢',
            driverEmail: 'correu electrònic del conductor â€¢',
            driverAddress: 'adreça de conductors â€¢',
            date: 'data â€¢',
            uniqueReference: 'referència física â€¢',
            useStandardTemplate: 'Utilitzar model estàndard',
        },
        column: {
            defaultLetter: 'Carta per defecte',
        },
        button: {
            setDefaultLetter: 'Establir per defecte',
            enable: 'Activar',
            disable: 'Desactivar',
            edit: 'Editar',
            delete: 'Suprimir',
            createDuplicate: 'Crear duplicat',
            save: 'Guardar',
            cancel: 'Cancel·lar',
            preview: ' Vista prèvia',
        },
        message: {
            setDefaultConfirmMesage: 'Està segur que desitja establir esta carta de deutor com a predeterminada?',
            enableConfirmMesage: 'Segur que vol activar-la?',
            disableConfirmMesage: 'Segur que vol desactivar-la?',
            deleteConfirmMesage: 'Segur que vol eliminar-la?',
        },
        error: {
            emptyContent: 'Per favor, proporcione el contingut per a previsualitzar la plantilla de carta',
            common: "S'ha produït un error en processar la seua sol·licitud, per favor intente-ho de nou més tard",
            supportedDynamicField1: 'Estos camps dinàmics',
            supportedDynamicField2: "només s'admeten per a la carta de deutor.",
        },
    },
    driverSubscriptions: {
        title: 'Subscripcions Premium del conductor: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        header: 'Subscripcions Premium',
        label: {
            subscriptionType: 'Tipus de subscripció',
            subscriptionStartDate: "Data d'inici de la subscripció",
            subscriptionStatus: 'Estat de la subscripció',
            renewalOrExpiryDate: 'Renovació / Data de caducitat',
            voltsCredited: 'Volts acreditats',
            journeysPlanned: 'Viatges previstos',
            active: 'Actiu',
            cancelled: 'Cancel·lat',
            action: 'Acció',
            cancel: 'Cancel·lar',
            cancelSubscription: 'Cancel·lar subscripció',
            terminate: 'Finalitzar',
            terminateSubscription: 'Finalitzar subscripció',
            freeTrial: 'Prova gratuïta',
            name: 'Nom',
            promotion: 'Promoció',
        },
        message: {
            cancelConfirmMessage:
                "Està segur que desitja cancel·lar la subscripció d'este usuari? Això cancel·larà la pròxima renovació automàtica de la subscripció.",
            terminateConfirmMessage:
                "Està segur que desitja posar fi a la subscripció d'este usuari? Això cancel·larà la pròxima renovació automàtica i detindrà tots els beneficis d'esta subscripció immediatament.",
            terminateConfirmMessageWithoutRenew:
                "Està segur que desitja posar fi a  la subscripció d'este usuari? Això detindrà immediatament tots els beneficis d'esta subscripció.",
        },
    },
    advertisingDropDownDefaultmessage:
        "Introduïsca un mínim de 3 caràcters d'ubicacions per a mostrar la llista d'estacions",
    rfidcardDropDownDefaultMessage:
        "Introduïsca un mínim de 3 caràcters d'ubicacions per a mostrar la llista de conductors/vehicles",
    chargeStationMapDropDownDefaultMessage:
        'Introduïsca un mínim de 3 caracteres para mostrar la lista de estaciones de recàrrega',
    startChargePageDropDownDefaultMessage:
        "Introduïsca caràcters d'ubicacions per a mostrar la llista de les ubicacions",
    groupGridDropDownDefaultMessage:
        "Introduïsca un mínim de 3 caràcters d'ubicacions per a mostrar la llista de conductors/vehicles",
    organisationdashBoardDefaultMessage:
        "Introduïsca un mínim de 3 caràcters d'ubicacions per a mostrar la llista de conductors/vehicles",
    rfidAssigncardDefaultDropDownMessage: 'Introduïsca un mínim de 3 caràcters del correu electrònic dels conductors',
    limitExceedAddressError: 'No es pot trobar la direcció en este moment',
    continueTypingSearch: 'Continuar escrivint per a rectificar la cerca',
    noFileChosen: 'Cap arxiu triat',
    ChooseFile: 'Triar arxiu',
    noOptions: 'Sense opcions',
    requiredField: 'El fitxer és un camp obligatori',
    removeImage: 'Llevar imatge',
    help: 'Ajuda',
    editor: {
        bold: 'Negreta',
        italic: 'Cursiva',
        underline: 'Subratllar',
        strikeThrough: 'Ratllar',
        monospace: 'Monoespai',
        superscript: 'Sobreíndex',
        subscript: 'Subíndex',
        blockType: 'Tipus de bloc',
        fontSize: 'Grandària de lletra',
        font: 'Font',
        unordered: 'Sense ordenar',
        ordered: 'Ordenat',
        indent: 'Sagnia',
        outdent: 'Desplegable',
        left: 'Esquerra',
        right: 'Dreta',
        center: 'Centre',
        justify: 'Justificar',
        colorPicker: 'Selector de color',
        link: 'Enllaç',
        unlink: 'Desvincular',
        embedded: 'Integrat',
        emoji: 'Emoji',
        remove: 'Eliminar',
        undo: 'Desfer',
        redo: 'Refer',
        image: 'Imatge',
    },
    map: {
        zoomIn: 'Ampliar',
        zoomOut: 'Allunyar',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Sol·licitar',
    cancel: 'Cancel·lar',
    noDataFound: "Ho sentim, no s'han trobat dades",
    globalService: {
        title: 'Registre global de servicis: ##COMPANY_BRAND_NAME## - Plataforma eMobility Service',
        status: {
            pending:
                'Per a comunicar-se amb els servicis globals, introduïsca la següent informació. Polsant el botó "Registrar-se" podrà establir la comunicació.',
            registered:
                'La Plataforma EMSP pot comunicar-se ara mateix amb els servicis globals. Si té algun problema per a comunicar-se, introduïsca la informació que apareix a continuació i faça clic en el botó "Tornar a registrar-se".',
        },
        insert: {
            url: 'URL',
            handshakeToken: "Fitxa d'apèndix",
        },
        placeholder: {
            url: 'URL',
            handshakeToken: "Fitxa d'apèndix",
        },
        label: {
            note: 'Nota',
            noteValue:
                "\"Fitxa d'apèndix\" ha d'introduir-se cada vegada que s'establix la comunicació amb els servicis globals. Per a identificar la fitxa d'apèndix",
            rfidSync: 'Sincronització RFID',
        },
        button: {
            register: 'Registre',
            reRegister: 'Re-registre',
        },
        error: {
            errorWhileCreatingGlobalService: 'Error en crear el servici global.',
            errorWhileUpdatingGlobalService: 'Error en actualitzar el servici global.',
        },
        endpointsTable: {
            header: 'Punt final de servici global',
            column: {
                identifer: 'Identificador',
                httpMethod: 'Mode Http',
                url: 'Url',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Desglossament detallat',
        total_cost: 'Cost total',
        conversion_rate: 'Taxa de conversió',
    },
    SubscriptionImages: {
        title: 'Subscripció Premium Imatges',
        manageSubscriptionImage: 'Gestionar Subscripcions imatge Premium',
        label: {
            name: 'Nom',
            description: 'Descripció',
            action: 'Acció',
            delete: 'Suprimir',
            image: 'Imatge',
            language: 'Idioma',
        },
        button: {
            edit: 'Editar',
            search: 'Buscar',
            reset: 'Restablir',
            add: 'Afegir',
        },
        message: {
            deleteConfirmMesage: 'Segur que vol eliminar-la?',
        },
        errors: {
            insertEnglishLanguageImage: 'Per favor, carregue la imatge en anglés',
            required: 'Es requerix una imatge',
        },
    },
    driverPaymentCards: {
        title: 'Targetes de Pagament del conductor: InstaVolt - Plataforma eMobility Service',
        header: 'Targetes de Pagament',
        label: {},
    },
};
